/* @sm/max-converter version 0.0.1 */
import QRCode from 'qrcode';

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var barcodes = {};

var CODE39$1 = {};

var Barcode$1 = {};

Object.defineProperty(Barcode$1, "__esModule", {
	value: true
});

function _classCallCheck$u(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Barcode = function Barcode(data, options) {
	_classCallCheck$u(this, Barcode);

	this.data = data;
	this.text = options.text || data;
	this.options = options;
};

Barcode$1.default = Barcode;

Object.defineProperty(CODE39$1, "__esModule", {
	value: true
});
CODE39$1.CODE39 = undefined;

var _createClass$n = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$c = Barcode$1;

var _Barcode3$c = _interopRequireDefault$A(_Barcode2$c);

function _interopRequireDefault$A(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$t(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$p(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$p(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_39#Encoding

var CODE39 = function (_Barcode) {
	_inherits$p(CODE39, _Barcode);

	function CODE39(data, options) {
		_classCallCheck$t(this, CODE39);

		data = data.toUpperCase();

		// Calculate mod43 checksum if enabled
		if (options.mod43) {
			data += getCharacter(mod43checksum(data));
		}

		return _possibleConstructorReturn$p(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
	}

	_createClass$n(CODE39, [{
		key: "encode",
		value: function encode() {
			// First character is always a *
			var result = getEncoding("*");

			// Take every character and add the binary representation to the result
			for (var i = 0; i < this.data.length; i++) {
				result += getEncoding(this.data[i]) + "0";
			}

			// Last character is always a *
			result += getEncoding("*");

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
		}
	}]);

	return CODE39;
}(_Barcode3$c.default);

// All characters. The position in the array is the (checksum) value


var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];

// The decimal representation of the characters, is converted to the
// corresponding binary with the getEncoding function
var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];

// Get the binary representation of a character by converting the encodings
// from decimal to binary
function getEncoding(character) {
	return getBinary(characterValue(character));
}

function getBinary(characterValue) {
	return encodings[characterValue].toString(2);
}

function getCharacter(characterValue) {
	return characters[characterValue];
}

function characterValue(character) {
	return characters.indexOf(character);
}

function mod43checksum(data) {
	var checksum = 0;
	for (var i = 0; i < data.length; i++) {
		checksum += characterValue(data[i]);
	}

	checksum = checksum % 43;
	return checksum;
}

CODE39$1.CODE39 = CODE39;

var CODE128$2 = {};

var CODE128_AUTO = {};

var CODE128$1 = {};

var constants$3 = {};

Object.defineProperty(constants$3, "__esModule", {
	value: true
});

var _SET_BY_CODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// constants for internal usage
var SET_A = constants$3.SET_A = 0;
var SET_B = constants$3.SET_B = 1;
var SET_C = constants$3.SET_C = 2;

// Special characters
constants$3.SHIFT = 98;
var START_A = constants$3.START_A = 103;
var START_B = constants$3.START_B = 104;
var START_C = constants$3.START_C = 105;
constants$3.MODULO = 103;
constants$3.STOP = 106;
constants$3.FNC1 = 207;

// Get set by start code
constants$3.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);

// Get next set by code
constants$3.SWAP = {
	101: SET_A,
	100: SET_B,
	99: SET_C
};

constants$3.A_START_CHAR = String.fromCharCode(208); // START_A + 105
constants$3.B_START_CHAR = String.fromCharCode(209); // START_B + 105
constants$3.C_START_CHAR = String.fromCharCode(210); // START_C + 105

// 128A (Code Set A)
// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
constants$3.A_CHARS = "[\x00-\x5F\xC8-\xCF]";

// 128B (Code Set B)
// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
constants$3.B_CHARS = "[\x20-\x7F\xC8-\xCF]";

// 128C (Code Set C)
// 00–99 (encodes two digits with a single code point) and FNC1
constants$3.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";

// CODE128 includes 107 symbols:
// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
// Each symbol consist of three black bars (1) and three white spaces (0).
constants$3.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];

Object.defineProperty(CODE128$1, "__esModule", {
	value: true
});

var _createClass$m = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$b = Barcode$1;

var _Barcode3$b = _interopRequireDefault$z(_Barcode2$b);

var _constants$b = constants$3;

function _interopRequireDefault$z(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$s(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$o(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$o(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is the master class,
// it does require the start code to be included in the string
var CODE128 = function (_Barcode) {
	_inherits$o(CODE128, _Barcode);

	function CODE128(data, options) {
		_classCallCheck$s(this, CODE128);

		// Get array of ascii codes from data
		var _this = _possibleConstructorReturn$o(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));

		_this.bytes = data.split('').map(function (char) {
			return char.charCodeAt(0);
		});
		return _this;
	}

	_createClass$m(CODE128, [{
		key: 'valid',
		value: function valid() {
			// ASCII value ranges 0-127, 200-211
			return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
			);
		}

		// The public encoding function

	}, {
		key: 'encode',
		value: function encode() {
			var bytes = this.bytes;
			// Remove the start code from the bytes and set its index
			var startIndex = bytes.shift() - 105;
			// Get start set by index
			var startSet = _constants$b.SET_BY_CODE[startIndex];

			if (startSet === undefined) {
				throw new RangeError('The encoding does not start with a start character.');
			}

			if (this.shouldEncodeAsEan128() === true) {
				bytes.unshift(_constants$b.FNC1);
			}

			// Start encode with the right type
			var encodingResult = CODE128.next(bytes, 1, startSet);

			return {
				text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
				data:
				// Add the start bits
				CODE128.getBar(startIndex) +
				// Add the encoded bits
				encodingResult.result +
				// Add the checksum
				CODE128.getBar((encodingResult.checksum + startIndex) % _constants$b.MODULO) +
				// Add the end bits
				CODE128.getBar(_constants$b.STOP)
			};
		}

		// GS1-128/EAN-128

	}, {
		key: 'shouldEncodeAsEan128',
		value: function shouldEncodeAsEan128() {
			var isEAN128 = this.options.ean128 || false;
			if (typeof isEAN128 === 'string') {
				isEAN128 = isEAN128.toLowerCase() === 'true';
			}
			return isEAN128;
		}

		// Get a bar symbol by index

	}], [{
		key: 'getBar',
		value: function getBar(index) {
			return _constants$b.BARS[index] ? _constants$b.BARS[index].toString() : '';
		}

		// Correct an index by a set and shift it from the bytes array

	}, {
		key: 'correctIndex',
		value: function correctIndex(bytes, set) {
			if (set === _constants$b.SET_A) {
				var charCode = bytes.shift();
				return charCode < 32 ? charCode + 64 : charCode - 32;
			} else if (set === _constants$b.SET_B) {
				return bytes.shift() - 32;
			} else {
				return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
			}
		}
	}, {
		key: 'next',
		value: function next(bytes, pos, set) {
			if (!bytes.length) {
				return { result: '', checksum: 0 };
			}

			var nextCode = void 0,
			    index = void 0;

			// Special characters
			if (bytes[0] >= 200) {
				index = bytes.shift() - 105;
				var nextSet = _constants$b.SWAP[index];

				// Swap to other set
				if (nextSet !== undefined) {
					nextCode = CODE128.next(bytes, pos + 1, nextSet);
				}
				// Continue on current set but encode a special character
				else {
						// Shift
						if ((set === _constants$b.SET_A || set === _constants$b.SET_B) && index === _constants$b.SHIFT) {
							// Convert the next character so that is encoded correctly
							bytes[0] = set === _constants$b.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
						}
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
			}
			// Continue encoding
			else {
					index = CODE128.correctIndex(bytes, set);
					nextCode = CODE128.next(bytes, pos + 1, set);
				}

			// Get the correct binary encoding and calculate the weight
			var enc = CODE128.getBar(index);
			var weight = index * pos;

			return {
				result: enc + nextCode.result,
				checksum: weight + nextCode.checksum
			};
		}
	}]);

	return CODE128;
}(_Barcode3$b.default);

CODE128$1.default = CODE128;

var auto = {};

Object.defineProperty(auto, "__esModule", {
	value: true
});

var _constants$a = constants$3;

// Match Set functions
var matchSetALength = function matchSetALength(string) {
	return string.match(new RegExp('^' + _constants$a.A_CHARS + '*'))[0].length;
};
var matchSetBLength = function matchSetBLength(string) {
	return string.match(new RegExp('^' + _constants$a.B_CHARS + '*'))[0].length;
};
var matchSetC = function matchSetC(string) {
	return string.match(new RegExp('^' + _constants$a.C_CHARS + '*'))[0];
};

// CODE128A or CODE128B
function autoSelectFromAB(string, isA) {
	var ranges = isA ? _constants$a.A_CHARS : _constants$a.B_CHARS;
	var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));

	if (untilC) {
		return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
	}

	var chars = string.match(new RegExp('^' + ranges + '+'))[0];

	if (chars.length === string.length) {
		return string;
	}

	return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
}

// CODE128C
function autoSelectFromC(string) {
	var cMatch = matchSetC(string);
	var length = cMatch.length;

	if (length === string.length) {
		return string;
	}

	string = string.substring(length);

	// Select A/B depending on the longest match
	var isA = matchSetALength(string) >= matchSetBLength(string);
	return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
}

// Detect Code Set (A, B or C) and format the string

auto.default = function (string) {
	var newString = void 0;
	var cLength = matchSetC(string).length;

	// Select 128C if the string start with enough digits
	if (cLength >= 2) {
		newString = _constants$a.C_START_CHAR + autoSelectFromC(string);
	} else {
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) > matchSetBLength(string);
		newString = (isA ? _constants$a.A_START_CHAR : _constants$a.B_START_CHAR) + autoSelectFromAB(string, isA);
	}

	return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
	function (match, char) {
		return String.fromCharCode(203) + char;
	});
};

Object.defineProperty(CODE128_AUTO, "__esModule", {
	value: true
});

var _CODE2$6 = CODE128$1;

var _CODE3$5 = _interopRequireDefault$y(_CODE2$6);

var _auto = auto;

var _auto2 = _interopRequireDefault$y(_auto);

function _interopRequireDefault$y(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$r(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$n(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$n(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128AUTO = function (_CODE) {
	_inherits$n(CODE128AUTO, _CODE);

	function CODE128AUTO(data, options) {
		_classCallCheck$r(this, CODE128AUTO);

		// ASCII value ranges 0-127, 200-211
		if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
			var _this = _possibleConstructorReturn$n(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
		} else {
			var _this = _possibleConstructorReturn$n(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
		}
		return _possibleConstructorReturn$n(_this);
	}

	return CODE128AUTO;
}(_CODE3$5.default);

CODE128_AUTO.default = CODE128AUTO;

var CODE128A$1 = {};

Object.defineProperty(CODE128A$1, "__esModule", {
	value: true
});

var _createClass$l = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$5 = CODE128$1;

var _CODE3$4 = _interopRequireDefault$x(_CODE2$5);

var _constants$9 = constants$3;

function _interopRequireDefault$x(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$q(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$m(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$m(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128A = function (_CODE) {
	_inherits$m(CODE128A, _CODE);

	function CODE128A(string, options) {
		_classCallCheck$q(this, CODE128A);

		return _possibleConstructorReturn$m(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants$9.A_START_CHAR + string, options));
	}

	_createClass$l(CODE128A, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants$9.A_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128A;
}(_CODE3$4.default);

CODE128A$1.default = CODE128A;

var CODE128B$1 = {};

Object.defineProperty(CODE128B$1, "__esModule", {
	value: true
});

var _createClass$k = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$4 = CODE128$1;

var _CODE3$3 = _interopRequireDefault$w(_CODE2$4);

var _constants$8 = constants$3;

function _interopRequireDefault$w(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$p(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$l(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$l(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128B = function (_CODE) {
	_inherits$l(CODE128B, _CODE);

	function CODE128B(string, options) {
		_classCallCheck$p(this, CODE128B);

		return _possibleConstructorReturn$l(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants$8.B_START_CHAR + string, options));
	}

	_createClass$k(CODE128B, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants$8.B_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128B;
}(_CODE3$3.default);

CODE128B$1.default = CODE128B;

var CODE128C$1 = {};

Object.defineProperty(CODE128C$1, "__esModule", {
	value: true
});

var _createClass$j = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$3 = CODE128$1;

var _CODE3$2 = _interopRequireDefault$v(_CODE2$3);

var _constants$7 = constants$3;

function _interopRequireDefault$v(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$o(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$k(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$k(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128C = function (_CODE) {
	_inherits$k(CODE128C, _CODE);

	function CODE128C(string, options) {
		_classCallCheck$o(this, CODE128C);

		return _possibleConstructorReturn$k(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants$7.C_START_CHAR + string, options));
	}

	_createClass$j(CODE128C, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants$7.C_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128C;
}(_CODE3$2.default);

CODE128C$1.default = CODE128C;

Object.defineProperty(CODE128$2, "__esModule", {
  value: true
});
CODE128$2.CODE128C = CODE128$2.CODE128B = CODE128$2.CODE128A = CODE128$2.CODE128 = undefined;

var _CODE128_AUTO = CODE128_AUTO;

var _CODE128_AUTO2 = _interopRequireDefault$u(_CODE128_AUTO);

var _CODE128A = CODE128A$1;

var _CODE128A2 = _interopRequireDefault$u(_CODE128A);

var _CODE128B = CODE128B$1;

var _CODE128B2 = _interopRequireDefault$u(_CODE128B);

var _CODE128C = CODE128C$1;

var _CODE128C2 = _interopRequireDefault$u(_CODE128C);

function _interopRequireDefault$u(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CODE128$2.CODE128 = _CODE128_AUTO2.default;
CODE128$2.CODE128A = _CODE128A2.default;
CODE128$2.CODE128B = _CODE128B2.default;
CODE128$2.CODE128C = _CODE128C2.default;

var EAN_UPC = {};

var EAN13$1 = {};

var constants$2 = {};

Object.defineProperty(constants$2, "__esModule", {
	value: true
});
// Standard start end and middle bits
constants$2.SIDE_BIN = '101';
constants$2.MIDDLE_BIN = '01010';

constants$2.BINARIES = {
	'L': [// The L (left) type of encoding
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'G': [// The G type of encoding
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
	'R': [// The R (right) type of encoding
	'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
	'O': [// The O (odd) encoding for UPC-E
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'E': [// The E (even) encoding for UPC-E
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
};

// Define the EAN-2 structure
constants$2.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];

// Define the EAN-5 structure
constants$2.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];

// Define the EAN-13 structure
constants$2.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

var EAN$1 = {};

var encoder = {};

Object.defineProperty(encoder, "__esModule", {
	value: true
});

var _constants$6 = constants$2;

// Encode data string
var encode$1 = function encode(data, structure, separator) {
	var encoded = data.split('').map(function (val, idx) {
		return _constants$6.BINARIES[structure[idx]];
	}).map(function (val, idx) {
		return val ? val[data[idx]] : '';
	});

	if (separator) {
		var last = data.length - 1;
		encoded = encoded.map(function (val, idx) {
			return idx < last ? val + separator : val;
		});
	}

	return encoded.join('');
};

encoder.default = encode$1;

Object.defineProperty(EAN$1, "__esModule", {
	value: true
});

var _createClass$i = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$5 = constants$2;

var _encoder$4 = encoder;

var _encoder2$4 = _interopRequireDefault$t(_encoder$4);

var _Barcode2$a = Barcode$1;

var _Barcode3$a = _interopRequireDefault$t(_Barcode2$a);

function _interopRequireDefault$t(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$n(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$j(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$j(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for EAN8 & EAN13
var EAN = function (_Barcode) {
	_inherits$j(EAN, _Barcode);

	function EAN(data, options) {
		_classCallCheck$n(this, EAN);

		// Make sure the font is not bigger than the space between the guard bars
		var _this = _possibleConstructorReturn$j(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));

		_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass$i(EAN, [{
		key: 'encode',
		value: function encode() {
			return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
		}
	}, {
		key: 'leftText',
		value: function leftText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode(data, structure) {
			return (0, _encoder2$4.default)(data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode(data, structure) {
			return (0, _encoder2$4.default)(data, structure);
		}
	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var textOptions = { fontSize: this.fontSize };
			var guardOptions = { height: this.guardHeight };

			return [{ data: _constants$5.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants$5.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants$5.SIDE_BIN, options: guardOptions }];
		}
	}, {
		key: 'encodeFlat',
		value: function encodeFlat() {
			var data = [_constants$5.SIDE_BIN, this.leftEncode(), _constants$5.MIDDLE_BIN, this.rightEncode(), _constants$5.SIDE_BIN];

			return {
				data: data.join(''),
				text: this.text
			};
		}
	}]);

	return EAN;
}(_Barcode3$a.default);

EAN$1.default = EAN;

Object.defineProperty(EAN13$1, "__esModule", {
	value: true
});

var _createClass$h = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get$1 = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants$4 = constants$2;

var _EAN2$2 = EAN$1;

var _EAN3$2 = _interopRequireDefault$s(_EAN2$2);

function _interopRequireDefault$s(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$m(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$i(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$i(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum$4 = function checksum(number) {
	var res = number.substr(0, 12).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 3 : sum + a;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN13 = function (_EAN) {
	_inherits$i(EAN13, _EAN);

	function EAN13(data, options) {
		_classCallCheck$m(this, EAN13);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{12}$/) !== -1) {
			data += checksum$4(data);
		}

		// Adds a last character to the end of the barcode
		var _this = _possibleConstructorReturn$i(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));

		_this.lastChar = options.lastChar;
		return _this;
	}

	_createClass$h(EAN13, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum$4(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(1, 6);
			var structure = _constants$4.EAN13_STRUCTURE[this.data[0]];
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(7, 6);
			return _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
		}

		// The "standard" way of printing EAN13 barcodes with guard bars

	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var data = _get$1(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);

			// Extend data with left digit & last character
			if (this.options.displayValue) {
				data.unshift({
					data: '000000000000',
					text: this.text.substr(0, 1),
					options: { textAlign: 'left', fontSize: this.fontSize }
				});

				if (this.options.lastChar) {
					data.push({
						data: '00'
					});
					data.push({
						data: '00000',
						text: this.options.lastChar,
						options: { fontSize: this.fontSize }
					});
				}
			}

			return data;
		}
	}]);

	return EAN13;
}(_EAN3$2.default);

EAN13$1.default = EAN13;

var EAN8$1 = {};

Object.defineProperty(EAN8$1, "__esModule", {
	value: true
});

var _createClass$g = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EAN2$1 = EAN$1;

var _EAN3$1 = _interopRequireDefault$r(_EAN2$1);

function _interopRequireDefault$r(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$l(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$h(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$h(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// http://www.barcodeisland.com/ean8.phtml

// Calculate the checksum digit
var checksum$3 = function checksum(number) {
	var res = number.substr(0, 7).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a : sum + a * 3;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN8 = function (_EAN) {
	_inherits$h(EAN8, _EAN);

	function EAN8(data, options) {
		_classCallCheck$l(this, EAN8);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{7}$/) !== -1) {
			data += checksum$3(data);
		}

		return _possibleConstructorReturn$h(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
	}

	_createClass$g(EAN8, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum$3(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(0, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(4, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
		}
	}]);

	return EAN8;
}(_EAN3$1.default);

EAN8$1.default = EAN8;

var EAN5$1 = {};

Object.defineProperty(EAN5$1, "__esModule", {
	value: true
});

var _createClass$f = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$3 = constants$2;

var _encoder$3 = encoder;

var _encoder2$3 = _interopRequireDefault$q(_encoder$3);

var _Barcode2$9 = Barcode$1;

var _Barcode3$9 = _interopRequireDefault$q(_Barcode2$9);

function _interopRequireDefault$q(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$k(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$g(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$g(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_5#Encoding

var checksum$2 = function checksum(data) {
	var result = data.split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 9 : sum + a * 3;
	}, 0);
	return result % 10;
};

var EAN5 = function (_Barcode) {
	_inherits$g(EAN5, _Barcode);

	function EAN5(data, options) {
		_classCallCheck$k(this, EAN5);

		return _possibleConstructorReturn$g(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
	}

	_createClass$f(EAN5, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{5}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var structure = _constants$3.EAN5_STRUCTURE[checksum$2(this.data)];
			return {
				data: '1011' + (0, _encoder2$3.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN5;
}(_Barcode3$9.default);

EAN5$1.default = EAN5;

var EAN2$1 = {};

Object.defineProperty(EAN2$1, "__esModule", {
	value: true
});

var _createClass$e = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$2 = constants$2;

var _encoder$2 = encoder;

var _encoder2$2 = _interopRequireDefault$p(_encoder$2);

var _Barcode2$8 = Barcode$1;

var _Barcode3$8 = _interopRequireDefault$p(_Barcode2$8);

function _interopRequireDefault$p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$f(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$f(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_2#Encoding

var EAN2 = function (_Barcode) {
	_inherits$f(EAN2, _Barcode);

	function EAN2(data, options) {
		_classCallCheck$j(this, EAN2);

		return _possibleConstructorReturn$f(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
	}

	_createClass$e(EAN2, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{2}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			// Choose the structure based on the number mod 4
			var structure = _constants$2.EAN2_STRUCTURE[parseInt(this.data) % 4];
			return {
				// Start bits + Encode the two digits with 01 in between
				data: '1011' + (0, _encoder2$2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN2;
}(_Barcode3$8.default);

EAN2$1.default = EAN2;

var UPC$1 = {};

Object.defineProperty(UPC$1, "__esModule", {
	value: true
});

var _createClass$d = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

UPC$1.checksum = checksum$1;

var _encoder$1 = encoder;

var _encoder2$1 = _interopRequireDefault$o(_encoder$1);

var _Barcode2$7 = Barcode$1;

var _Barcode3$7 = _interopRequireDefault$o(_Barcode2$7);

function _interopRequireDefault$o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$e(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$e(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding

var UPC = function (_Barcode) {
	_inherits$e(UPC, _Barcode);

	function UPC(data, options) {
		_classCallCheck$i(this, UPC);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{11}$/) !== -1) {
			data += checksum$1(data);
		}

		var _this = _possibleConstructorReturn$e(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass$d(UPC, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum$1(this.data);
		}
	}, {
		key: "encode",
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: "flatEncoding",
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += (0, _encoder2$1.default)(this.data.substr(0, 6), "LLLLLL");
			result += "01010";
			result += (0, _encoder2$1.default)(this.data.substr(6, 6), "RRRRRR");
			result += "101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "guardedEncoding",
		value: function guardedEncoding() {
			var result = [];

			// Add the first digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(0, 1),
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101" + (0, _encoder2$1.default)(this.data[0], "L"),
				options: { height: this.guardHeight }
			});

			// Add the left side
			result.push({
				data: (0, _encoder2$1.default)(this.data.substr(1, 5), "LLLLL"),
				text: this.text.substr(1, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the middle bits
			result.push({
				data: "01010",
				options: { height: this.guardHeight }
			});

			// Add the right side
			result.push({
				data: (0, _encoder2$1.default)(this.data.substr(6, 5), "RRRRR"),
				text: this.text.substr(6, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: (0, _encoder2$1.default)(this.data[11], "R") + "101",
				options: { height: this.guardHeight }
			});

			// Add the last digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(11, 1),
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}]);

	return UPC;
}(_Barcode3$7.default);

// Calulate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit


function checksum$1(number) {
	var result = 0;

	var i;
	for (i = 1; i < 11; i += 2) {
		result += parseInt(number[i]);
	}
	for (i = 0; i < 11; i += 2) {
		result += parseInt(number[i]) * 3;
	}

	return (10 - result % 10) % 10;
}

UPC$1.default = UPC;

var UPCE$1 = {};

Object.defineProperty(UPCE$1, "__esModule", {
	value: true
});

var _createClass$c = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _encoder = encoder;

var _encoder2 = _interopRequireDefault$n(_encoder);

var _Barcode2$6 = Barcode$1;

var _Barcode3$6 = _interopRequireDefault$n(_Barcode2$6);

var _UPC$1 = UPC$1;

function _interopRequireDefault$n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$d(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$d(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
//
// UPC-E documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E

var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];

var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];

var UPCE = function (_Barcode) {
	_inherits$d(UPCE, _Barcode);

	function UPCE(data, options) {
		_classCallCheck$h(this, UPCE);

		var _this = _possibleConstructorReturn$d(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
		// Code may be 6 or 8 digits;
		// A 7 digit code is ambiguous as to whether the extra digit
		// is a UPC-A check or number system digit.


		_this.isValid = false;
		if (data.search(/^[0-9]{6}$/) !== -1) {
			_this.middleDigits = data;
			_this.upcA = expandToUPCA(data, "0");
			_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
			_this.isValid = true;
		} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
			_this.middleDigits = data.substring(1, data.length - 1);
			_this.upcA = expandToUPCA(_this.middleDigits, data[0]);

			if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
				_this.isValid = true;
			} else {
				// checksum mismatch
				return _possibleConstructorReturn$d(_this);
			}
		} else {
			return _possibleConstructorReturn$d(_this);
		}

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass$c(UPCE, [{
		key: 'valid',
		value: function valid() {
			return this.isValid;
		}
	}, {
		key: 'encode',
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: 'flatEncoding',
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += this.encodeMiddleDigits();
			result += "010101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: 'guardedEncoding',
		value: function guardedEncoding() {
			var result = [];

			// Add the UPC-A number system digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[0],
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101",
				options: { height: this.guardHeight }
			});

			// Add the 6 UPC-E digits
			result.push({
				data: this.encodeMiddleDigits(),
				text: this.text.substring(1, 7),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: "010101",
				options: { height: this.guardHeight }
			});

			// Add the UPC-A check digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[7],
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}, {
		key: 'encodeMiddleDigits',
		value: function encodeMiddleDigits() {
			var numberSystem = this.upcA[0];
			var checkDigit = this.upcA[this.upcA.length - 1];
			var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
			return (0, _encoder2.default)(this.middleDigits, parity);
		}
	}]);

	return UPCE;
}(_Barcode3$6.default);

function expandToUPCA(middleDigits, numberSystem) {
	var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
	var expansion = EXPANSIONS[lastUpcE];

	var result = "";
	var digitIndex = 0;
	for (var i = 0; i < expansion.length; i++) {
		var c = expansion[i];
		if (c === 'X') {
			result += middleDigits[digitIndex++];
		} else {
			result += c;
		}
	}

	result = '' + numberSystem + result;
	return '' + result + (0, _UPC$1.checksum)(result);
}

UPCE$1.default = UPCE;

Object.defineProperty(EAN_UPC, "__esModule", {
  value: true
});
EAN_UPC.UPCE = EAN_UPC.UPC = EAN_UPC.EAN2 = EAN_UPC.EAN5 = EAN_UPC.EAN8 = EAN_UPC.EAN13 = undefined;

var _EAN = EAN13$1;

var _EAN2 = _interopRequireDefault$m(_EAN);

var _EAN3 = EAN8$1;

var _EAN4 = _interopRequireDefault$m(_EAN3);

var _EAN5 = EAN5$1;

var _EAN6 = _interopRequireDefault$m(_EAN5);

var _EAN7 = EAN2$1;

var _EAN8 = _interopRequireDefault$m(_EAN7);

var _UPC = UPC$1;

var _UPC2 = _interopRequireDefault$m(_UPC);

var _UPCE = UPCE$1;

var _UPCE2 = _interopRequireDefault$m(_UPCE);

function _interopRequireDefault$m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

EAN_UPC.EAN13 = _EAN2.default;
EAN_UPC.EAN8 = _EAN4.default;
EAN_UPC.EAN5 = _EAN6.default;
EAN_UPC.EAN2 = _EAN8.default;
EAN_UPC.UPC = _UPC2.default;
EAN_UPC.UPCE = _UPCE2.default;

var ITF$2 = {};

var ITF$1 = {};

var constants$1 = {};

Object.defineProperty(constants$1, "__esModule", {
	value: true
});
constants$1.START_BIN = '1010';
constants$1.END_BIN = '11101';

constants$1.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];

Object.defineProperty(ITF$1, "__esModule", {
	value: true
});

var _createClass$b = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants$1 = constants$1;

var _Barcode2$5 = Barcode$1;

var _Barcode3$5 = _interopRequireDefault$l(_Barcode2$5);

function _interopRequireDefault$l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$c(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITF = function (_Barcode) {
	_inherits$c(ITF, _Barcode);

	function ITF() {
		_classCallCheck$g(this, ITF);

		return _possibleConstructorReturn$c(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
	}

	_createClass$b(ITF, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^([0-9]{2})+$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var _this2 = this;

			// Calculate all the digit pairs
			var encoded = this.data.match(/.{2}/g).map(function (pair) {
				return _this2.encodePair(pair);
			}).join('');

			return {
				data: _constants$1.START_BIN + encoded + _constants$1.END_BIN,
				text: this.text
			};
		}

		// Calculate the data of a number pair

	}, {
		key: 'encodePair',
		value: function encodePair(pair) {
			var second = _constants$1.BINARIES[pair[1]];

			return _constants$1.BINARIES[pair[0]].split('').map(function (first, idx) {
				return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
			}).join('');
		}
	}]);

	return ITF;
}(_Barcode3$5.default);

ITF$1.default = ITF;

var ITF14$1 = {};

Object.defineProperty(ITF14$1, "__esModule", {
	value: true
});

var _createClass$a = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ITF2$1 = ITF$1;

var _ITF3$1 = _interopRequireDefault$k(_ITF2$1);

function _interopRequireDefault$k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$b(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Calculate the checksum digit
var checksum = function checksum(data) {
	var res = data.substr(0, 13).split('').map(function (num) {
		return parseInt(num, 10);
	}).reduce(function (sum, n, idx) {
		return sum + n * (3 - idx % 2 * 2);
	}, 0);

	return Math.ceil(res / 10) * 10 - res;
};

var ITF14 = function (_ITF) {
	_inherits$b(ITF14, _ITF);

	function ITF14(data, options) {
		_classCallCheck$f(this, ITF14);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{13}$/) !== -1) {
			data += checksum(data);
		}
		return _possibleConstructorReturn$b(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
	}

	_createClass$a(ITF14, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
		}
	}]);

	return ITF14;
}(_ITF3$1.default);

ITF14$1.default = ITF14;

Object.defineProperty(ITF$2, "__esModule", {
  value: true
});
ITF$2.ITF14 = ITF$2.ITF = undefined;

var _ITF$1 = ITF$1;

var _ITF2 = _interopRequireDefault$j(_ITF$1);

var _ITF3 = ITF14$1;

var _ITF4 = _interopRequireDefault$j(_ITF3);

function _interopRequireDefault$j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

ITF$2.ITF = _ITF2.default;
ITF$2.ITF14 = _ITF4.default;

var MSI$2 = {};

var MSI$1 = {};

Object.defineProperty(MSI$1, "__esModule", {
	value: true
});

var _createClass$9 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$4 = Barcode$1;

var _Barcode3$4 = _interopRequireDefault$i(_Barcode2$4);

function _interopRequireDefault$i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$a(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup

var MSI = function (_Barcode) {
	_inherits$a(MSI, _Barcode);

	function MSI(data, options) {
		_classCallCheck$e(this, MSI);

		return _possibleConstructorReturn$a(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
	}

	_createClass$9(MSI, [{
		key: "encode",
		value: function encode() {
			// Start bits
			var ret = "110";

			for (var i = 0; i < this.data.length; i++) {
				// Convert the character to binary (always 4 binary digits)
				var digit = parseInt(this.data[i]);
				var bin = digit.toString(2);
				bin = addZeroes(bin, 4 - bin.length);

				// Add 100 for every zero and 110 for every 1
				for (var b = 0; b < bin.length; b++) {
					ret += bin[b] == "0" ? "100" : "110";
				}
			}

			// End bits
			ret += "1001";

			return {
				data: ret,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]+$/) !== -1;
		}
	}]);

	return MSI;
}(_Barcode3$4.default);

function addZeroes(number, n) {
	for (var i = 0; i < n; i++) {
		number = "0" + number;
	}
	return number;
}

MSI$1.default = MSI;

var MSI10$1 = {};

var checksums = {};

Object.defineProperty(checksums, "__esModule", {
	value: true
});
checksums.mod10 = mod10;
checksums.mod11 = mod11;
function mod10(number) {
	var sum = 0;
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[i]);
		if ((i + number.length) % 2 === 0) {
			sum += n;
		} else {
			sum += n * 2 % 10 + Math.floor(n * 2 / 10);
		}
	}
	return (10 - sum % 10) % 10;
}

function mod11(number) {
	var sum = 0;
	var weights = [2, 3, 4, 5, 6, 7];
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[number.length - 1 - i]);
		sum += weights[i % weights.length] * n;
	}
	return (11 - sum % 11) % 11;
}

Object.defineProperty(MSI10$1, "__esModule", {
	value: true
});

var _MSI2$4 = MSI$1;

var _MSI3$4 = _interopRequireDefault$h(_MSI2$4);

var _checksums$3 = checksums;

function _interopRequireDefault$h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$d(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI10 = function (_MSI) {
	_inherits$9(MSI10, _MSI);

	function MSI10(data, options) {
		_classCallCheck$d(this, MSI10);

		return _possibleConstructorReturn$9(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums$3.mod10)(data), options));
	}

	return MSI10;
}(_MSI3$4.default);

MSI10$1.default = MSI10;

var MSI11$1 = {};

Object.defineProperty(MSI11$1, "__esModule", {
	value: true
});

var _MSI2$3 = MSI$1;

var _MSI3$3 = _interopRequireDefault$g(_MSI2$3);

var _checksums$2 = checksums;

function _interopRequireDefault$g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI11 = function (_MSI) {
	_inherits$8(MSI11, _MSI);

	function MSI11(data, options) {
		_classCallCheck$c(this, MSI11);

		return _possibleConstructorReturn$8(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums$2.mod11)(data), options));
	}

	return MSI11;
}(_MSI3$3.default);

MSI11$1.default = MSI11;

var MSI1010$1 = {};

Object.defineProperty(MSI1010$1, "__esModule", {
	value: true
});

var _MSI2$2 = MSI$1;

var _MSI3$2 = _interopRequireDefault$f(_MSI2$2);

var _checksums$1 = checksums;

function _interopRequireDefault$f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1010 = function (_MSI) {
	_inherits$7(MSI1010, _MSI);

	function MSI1010(data, options) {
		_classCallCheck$b(this, MSI1010);

		data += (0, _checksums$1.mod10)(data);
		data += (0, _checksums$1.mod10)(data);
		return _possibleConstructorReturn$7(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
	}

	return MSI1010;
}(_MSI3$2.default);

MSI1010$1.default = MSI1010;

var MSI1110$1 = {};

Object.defineProperty(MSI1110$1, "__esModule", {
	value: true
});

var _MSI2$1 = MSI$1;

var _MSI3$1 = _interopRequireDefault$e(_MSI2$1);

var _checksums = checksums;

function _interopRequireDefault$e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1110 = function (_MSI) {
	_inherits$6(MSI1110, _MSI);

	function MSI1110(data, options) {
		_classCallCheck$a(this, MSI1110);

		data += (0, _checksums.mod11)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn$6(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
	}

	return MSI1110;
}(_MSI3$1.default);

MSI1110$1.default = MSI1110;

Object.defineProperty(MSI$2, "__esModule", {
  value: true
});
MSI$2.MSI1110 = MSI$2.MSI1010 = MSI$2.MSI11 = MSI$2.MSI10 = MSI$2.MSI = undefined;

var _MSI$1 = MSI$1;

var _MSI2 = _interopRequireDefault$d(_MSI$1);

var _MSI3 = MSI10$1;

var _MSI4 = _interopRequireDefault$d(_MSI3);

var _MSI5 = MSI11$1;

var _MSI6 = _interopRequireDefault$d(_MSI5);

var _MSI7 = MSI1010$1;

var _MSI8 = _interopRequireDefault$d(_MSI7);

var _MSI9 = MSI1110$1;

var _MSI10 = _interopRequireDefault$d(_MSI9);

function _interopRequireDefault$d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

MSI$2.MSI = _MSI2.default;
MSI$2.MSI10 = _MSI4.default;
MSI$2.MSI11 = _MSI6.default;
MSI$2.MSI1010 = _MSI8.default;
MSI$2.MSI1110 = _MSI10.default;

var pharmacode$1 = {};

Object.defineProperty(pharmacode$1, "__esModule", {
	value: true
});
pharmacode$1.pharmacode = undefined;

var _createClass$8 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$3 = Barcode$1;

var _Barcode3$3 = _interopRequireDefault$c(_Barcode2$3);

function _interopRequireDefault$c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf

var pharmacode = function (_Barcode) {
	_inherits$5(pharmacode, _Barcode);

	function pharmacode(data, options) {
		_classCallCheck$9(this, pharmacode);

		var _this = _possibleConstructorReturn$5(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));

		_this.number = parseInt(data, 10);
		return _this;
	}

	_createClass$8(pharmacode, [{
		key: "encode",
		value: function encode() {
			var z = this.number;
			var result = "";

			// http://i.imgur.com/RMm4UDJ.png
			// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
			while (!isNaN(z) && z != 0) {
				if (z % 2 === 0) {
					// Even
					result = "11100" + result;
					z = (z - 2) / 2;
				} else {
					// Odd
					result = "100" + result;
					z = (z - 1) / 2;
				}
			}

			// Remove the two last zeroes
			result = result.slice(0, -2);

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.number >= 3 && this.number <= 131070;
		}
	}]);

	return pharmacode;
}(_Barcode3$3.default);

pharmacode$1.pharmacode = pharmacode;

var codabar$1 = {};

Object.defineProperty(codabar$1, "__esModule", {
	value: true
});
codabar$1.codabar = undefined;

var _createClass$7 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2$2 = Barcode$1;

var _Barcode3$2 = _interopRequireDefault$b(_Barcode2$2);

function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
// http://www.barcodeisland.com/codabar.phtml

var codabar = function (_Barcode) {
	_inherits$4(codabar, _Barcode);

	function codabar(data, options) {
		_classCallCheck$8(this, codabar);

		if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
			data = "A" + data + "A";
		}

		var _this = _possibleConstructorReturn$4(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));

		_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
		return _this;
	}

	_createClass$7(codabar, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
		}
	}, {
		key: "encode",
		value: function encode() {
			var result = [];
			var encodings = this.getEncodings();
			for (var i = 0; i < this.data.length; i++) {
				result.push(encodings[this.data.charAt(i)]);
				// for all characters except the last, append a narrow-space ("0")
				if (i !== this.data.length - 1) {
					result.push("0");
				}
			}
			return {
				text: this.text,
				data: result.join('')
			};
		}
	}, {
		key: "getEncodings",
		value: function getEncodings() {
			return {
				"0": "101010011",
				"1": "101011001",
				"2": "101001011",
				"3": "110010101",
				"4": "101101001",
				"5": "110101001",
				"6": "100101011",
				"7": "100101101",
				"8": "100110101",
				"9": "110100101",
				"-": "101001101",
				"$": "101100101",
				":": "1101011011",
				"/": "1101101011",
				".": "1101101101",
				"+": "1011011011",
				"A": "1011001001",
				"B": "1001001011",
				"C": "1010010011",
				"D": "1010011001"
			};
		}
	}]);

	return codabar;
}(_Barcode3$2.default);

codabar$1.codabar = codabar;

var CODE93$2 = {};

var CODE93$1 = {};

var constants = {};

Object.defineProperty(constants, "__esModule", {
	value: true
});
// The position in the array is the (checksum) value
constants.SYMBOLS = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '-', '.', ' ', '$', '/', '+', '%',
// Only used for csum and multi-symbols character encodings
'($)', '(%)', '(/)', '(+)',
// Start/Stop
'\xff'];

// Order matches SYMBOLS array
constants.BINARIES = ['100010100', '101001000', '101000100', '101000010', '100101000', '100100100', '100100010', '101010000', '100010010', '100001010', '110101000', '110100100', '110100010', '110010100', '110010010', '110001010', '101101000', '101100100', '101100010', '100110100', '100011010', '101011000', '101001100', '101000110', '100101100', '100010110', '110110100', '110110010', '110101100', '110100110', '110010110', '110011010', '101101100', '101100110', '100110110', '100111010', '100101110', '111010100', '111010010', '111001010', '101101110', '101110110', '110101110', '100100110', '111011010', '111010110', '100110010', '101011110'];

// Multi-symbol characters (Full ASCII Code 93)
constants.MULTI_SYMBOLS = {
	'\x00': ['(%)', 'U'],
	'\x01': ['($)', 'A'],
	'\x02': ['($)', 'B'],
	'\x03': ['($)', 'C'],
	'\x04': ['($)', 'D'],
	'\x05': ['($)', 'E'],
	'\x06': ['($)', 'F'],
	'\x07': ['($)', 'G'],
	'\x08': ['($)', 'H'],
	'\x09': ['($)', 'I'],
	'\x0a': ['($)', 'J'],
	'\x0b': ['($)', 'K'],
	'\x0c': ['($)', 'L'],
	'\x0d': ['($)', 'M'],
	'\x0e': ['($)', 'N'],
	'\x0f': ['($)', 'O'],
	'\x10': ['($)', 'P'],
	'\x11': ['($)', 'Q'],
	'\x12': ['($)', 'R'],
	'\x13': ['($)', 'S'],
	'\x14': ['($)', 'T'],
	'\x15': ['($)', 'U'],
	'\x16': ['($)', 'V'],
	'\x17': ['($)', 'W'],
	'\x18': ['($)', 'X'],
	'\x19': ['($)', 'Y'],
	'\x1a': ['($)', 'Z'],
	'\x1b': ['(%)', 'A'],
	'\x1c': ['(%)', 'B'],
	'\x1d': ['(%)', 'C'],
	'\x1e': ['(%)', 'D'],
	'\x1f': ['(%)', 'E'],
	'!': ['(/)', 'A'],
	'"': ['(/)', 'B'],
	'#': ['(/)', 'C'],
	'&': ['(/)', 'F'],
	'\'': ['(/)', 'G'],
	'(': ['(/)', 'H'],
	')': ['(/)', 'I'],
	'*': ['(/)', 'J'],
	',': ['(/)', 'L'],
	':': ['(/)', 'Z'],
	';': ['(%)', 'F'],
	'<': ['(%)', 'G'],
	'=': ['(%)', 'H'],
	'>': ['(%)', 'I'],
	'?': ['(%)', 'J'],
	'@': ['(%)', 'V'],
	'[': ['(%)', 'K'],
	'\\': ['(%)', 'L'],
	']': ['(%)', 'M'],
	'^': ['(%)', 'N'],
	'_': ['(%)', 'O'],
	'`': ['(%)', 'W'],
	'a': ['(+)', 'A'],
	'b': ['(+)', 'B'],
	'c': ['(+)', 'C'],
	'd': ['(+)', 'D'],
	'e': ['(+)', 'E'],
	'f': ['(+)', 'F'],
	'g': ['(+)', 'G'],
	'h': ['(+)', 'H'],
	'i': ['(+)', 'I'],
	'j': ['(+)', 'J'],
	'k': ['(+)', 'K'],
	'l': ['(+)', 'L'],
	'm': ['(+)', 'M'],
	'n': ['(+)', 'N'],
	'o': ['(+)', 'O'],
	'p': ['(+)', 'P'],
	'q': ['(+)', 'Q'],
	'r': ['(+)', 'R'],
	's': ['(+)', 'S'],
	't': ['(+)', 'T'],
	'u': ['(+)', 'U'],
	'v': ['(+)', 'V'],
	'w': ['(+)', 'W'],
	'x': ['(+)', 'X'],
	'y': ['(+)', 'Y'],
	'z': ['(+)', 'Z'],
	'{': ['(%)', 'P'],
	'|': ['(%)', 'Q'],
	'}': ['(%)', 'R'],
	'~': ['(%)', 'S'],
	'\x7f': ['(%)', 'T']
};

Object.defineProperty(CODE93$1, "__esModule", {
	value: true
});

var _createClass$6 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = constants;

var _Barcode2$1 = Barcode$1;

var _Barcode3$1 = _interopRequireDefault$a(_Barcode2$1);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_93#Detailed_outline

var CODE93 = function (_Barcode) {
	_inherits$3(CODE93, _Barcode);

	function CODE93(data, options) {
		_classCallCheck$7(this, CODE93);

		return _possibleConstructorReturn$3(this, (CODE93.__proto__ || Object.getPrototypeOf(CODE93)).call(this, data, options));
	}

	_createClass$6(CODE93, [{
		key: 'valid',
		value: function valid() {
			return (/^[0-9A-Z\-. $/+%]+$/.test(this.data)
			);
		}
	}, {
		key: 'encode',
		value: function encode() {
			var symbols = this.data.split('').flatMap(function (c) {
				return _constants.MULTI_SYMBOLS[c] || c;
			});
			var encoded = symbols.map(function (s) {
				return CODE93.getEncoding(s);
			}).join('');

			// Compute checksum symbols
			var csumC = CODE93.checksum(symbols, 20);
			var csumK = CODE93.checksum(symbols.concat(csumC), 15);

			return {
				text: this.text,
				data:
				// Add the start bits
				CODE93.getEncoding('\xff') +
				// Add the encoded bits
				encoded +
				// Add the checksum
				CODE93.getEncoding(csumC) + CODE93.getEncoding(csumK) +
				// Add the stop bits
				CODE93.getEncoding('\xff') +
				// Add the termination bit
				'1'
			};
		}

		// Get the binary encoding of a symbol

	}], [{
		key: 'getEncoding',
		value: function getEncoding(symbol) {
			return _constants.BINARIES[CODE93.symbolValue(symbol)];
		}

		// Get the symbol for a symbol value

	}, {
		key: 'getSymbol',
		value: function getSymbol(symbolValue) {
			return _constants.SYMBOLS[symbolValue];
		}

		// Get the symbol value of a symbol

	}, {
		key: 'symbolValue',
		value: function symbolValue(symbol) {
			return _constants.SYMBOLS.indexOf(symbol);
		}

		// Calculate a checksum symbol

	}, {
		key: 'checksum',
		value: function checksum(symbols, maxWeight) {
			var csum = symbols.slice().reverse().reduce(function (sum, symbol, idx) {
				var weight = idx % maxWeight + 1;
				return sum + CODE93.symbolValue(symbol) * weight;
			}, 0);

			return CODE93.getSymbol(csum % 47);
		}
	}]);

	return CODE93;
}(_Barcode3$1.default);

CODE93$1.default = CODE93;

var CODE93FullASCII$1 = {};

Object.defineProperty(CODE93FullASCII$1, "__esModule", {
	value: true
});

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2$2 = CODE93$1;

var _CODE3$1 = _interopRequireDefault$9(_CODE2$2);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/Code_93#Full_ASCII_Code_93

var CODE93FullASCII = function (_CODE) {
	_inherits$2(CODE93FullASCII, _CODE);

	function CODE93FullASCII(data, options) {
		_classCallCheck$6(this, CODE93FullASCII);

		return _possibleConstructorReturn$2(this, (CODE93FullASCII.__proto__ || Object.getPrototypeOf(CODE93FullASCII)).call(this, data, options));
	}

	_createClass$5(CODE93FullASCII, [{
		key: 'valid',
		value: function valid() {
			return (/^[\x00-\x7f]+$/.test(this.data)
			);
		}
	}]);

	return CODE93FullASCII;
}(_CODE3$1.default);

CODE93FullASCII$1.default = CODE93FullASCII;

Object.defineProperty(CODE93$2, "__esModule", {
  value: true
});
CODE93$2.CODE93FullASCII = CODE93$2.CODE93 = undefined;

var _CODE$1 = CODE93$1;

var _CODE2$1 = _interopRequireDefault$8(_CODE$1);

var _CODE93FullASCII = CODE93FullASCII$1;

var _CODE93FullASCII2 = _interopRequireDefault$8(_CODE93FullASCII);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CODE93$2.CODE93 = _CODE2$1.default;
CODE93$2.CODE93FullASCII = _CODE93FullASCII2.default;

var GenericBarcode$1 = {};

Object.defineProperty(GenericBarcode$1, "__esModule", {
	value: true
});
GenericBarcode$1.GenericBarcode = undefined;

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = Barcode$1;

var _Barcode3 = _interopRequireDefault$7(_Barcode2);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericBarcode = function (_Barcode) {
	_inherits$1(GenericBarcode, _Barcode);

	function GenericBarcode(data, options) {
		_classCallCheck$5(this, GenericBarcode);

		return _possibleConstructorReturn$1(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
	}

	// Return the corresponding binary numbers for the data provided


	_createClass$4(GenericBarcode, [{
		key: "encode",
		value: function encode() {
			return {
				data: "10101010101010101010101010101010101010101",
				text: this.text
			};
		}

		// Resturn true/false if the string provided is valid for this encoder

	}, {
		key: "valid",
		value: function valid() {
			return true;
		}
	}]);

	return GenericBarcode;
}(_Barcode3.default);

GenericBarcode$1.GenericBarcode = GenericBarcode;

Object.defineProperty(barcodes, "__esModule", {
	value: true
});

var _CODE = CODE39$1;

var _CODE2 = CODE128$2;

var _EAN_UPC = EAN_UPC;

var _ITF = ITF$2;

var _MSI = MSI$2;

var _pharmacode = pharmacode$1;

var _codabar = codabar$1;

var _CODE3 = CODE93$2;

var _GenericBarcode = GenericBarcode$1;

barcodes.default = {
	CODE39: _CODE.CODE39,
	CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
	EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
	ITF14: _ITF.ITF14,
	ITF: _ITF.ITF,
	MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
	pharmacode: _pharmacode.pharmacode,
	codabar: _codabar.codabar,
	CODE93: _CODE3.CODE93, CODE93FullASCII: _CODE3.CODE93FullASCII,
	GenericBarcode: _GenericBarcode.GenericBarcode
};

var merge = {};

Object.defineProperty(merge, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

merge.default = function (old, replaceObj) {
  return _extends({}, old, replaceObj);
};

var linearizeEncodings$1 = {};

Object.defineProperty(linearizeEncodings$1, "__esModule", {
	value: true
});
linearizeEncodings$1.default = linearizeEncodings;

// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
// Convert to [1-1, 1-2, 2, 3-1, 3-2]

function linearizeEncodings(encodings) {
	var linearEncodings = [];
	function nextLevel(encoded) {
		if (Array.isArray(encoded)) {
			for (var i = 0; i < encoded.length; i++) {
				nextLevel(encoded[i]);
			}
		} else {
			encoded.text = encoded.text || "";
			encoded.data = encoded.data || "";
			linearEncodings.push(encoded);
		}
	}
	nextLevel(encodings);

	return linearEncodings;
}

var fixOptions$1 = {};

Object.defineProperty(fixOptions$1, "__esModule", {
	value: true
});
fixOptions$1.default = fixOptions;


function fixOptions(options) {
	// Fix the margins
	options.marginTop = options.marginTop || options.margin;
	options.marginBottom = options.marginBottom || options.margin;
	options.marginRight = options.marginRight || options.margin;
	options.marginLeft = options.marginLeft || options.margin;

	return options;
}

var getRenderProperties$1 = {};

var getOptionsFromElement$1 = {};

var optionsFromStrings$1 = {};

Object.defineProperty(optionsFromStrings$1, "__esModule", {
	value: true
});
optionsFromStrings$1.default = optionsFromStrings;

// Convert string to integers/booleans where it should be

function optionsFromStrings(options) {
	var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];

	for (var intOption in intOptions) {
		if (intOptions.hasOwnProperty(intOption)) {
			intOption = intOptions[intOption];
			if (typeof options[intOption] === "string") {
				options[intOption] = parseInt(options[intOption], 10);
			}
		}
	}

	if (typeof options["displayValue"] === "string") {
		options["displayValue"] = options["displayValue"] != "false";
	}

	return options;
}

var defaults$1 = {};

Object.defineProperty(defaults$1, "__esModule", {
	value: true
});
var defaults = {
	width: 2,
	height: 100,
	format: "auto",
	displayValue: true,
	fontOptions: "",
	font: "monospace",
	text: undefined,
	textAlign: "center",
	textPosition: "bottom",
	textMargin: 2,
	fontSize: 20,
	background: "#ffffff",
	lineColor: "#000000",
	margin: 10,
	marginTop: undefined,
	marginBottom: undefined,
	marginLeft: undefined,
	marginRight: undefined,
	valid: function valid() {}
};

defaults$1.default = defaults;

Object.defineProperty(getOptionsFromElement$1, "__esModule", {
	value: true
});

var _optionsFromStrings$1 = optionsFromStrings$1;

var _optionsFromStrings2$1 = _interopRequireDefault$6(_optionsFromStrings$1);

var _defaults$1 = defaults$1;

var _defaults2$1 = _interopRequireDefault$6(_defaults$1);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptionsFromElement(element) {
	var options = {};
	for (var property in _defaults2$1.default) {
		if (_defaults2$1.default.hasOwnProperty(property)) {
			// jsbarcode-*
			if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
				options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
			}

			// data-*
			if (element.hasAttribute("data-" + property.toLowerCase())) {
				options[property] = element.getAttribute("data-" + property.toLowerCase());
			}
		}
	}

	options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");

	// Since all atributes are string they need to be converted to integers
	options = (0, _optionsFromStrings2$1.default)(options);

	return options;
}

getOptionsFromElement$1.default = getOptionsFromElement;

var renderers = {};

var canvas = {};

var shared = {};

Object.defineProperty(shared, "__esModule", {
	value: true
});
shared.getTotalWidthOfEncodings = shared.calculateEncodingAttributes = shared.getBarcodePadding = shared.getEncodingHeight = shared.getMaximumHeightOfEncodings = undefined;

var _merge$3 = merge;

var _merge2$3 = _interopRequireDefault$5(_merge$3);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEncodingHeight(encoding, options) {
	return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
}

function getBarcodePadding(textWidth, barcodeWidth, options) {
	if (options.displayValue && barcodeWidth < textWidth) {
		if (options.textAlign == "center") {
			return Math.floor((textWidth - barcodeWidth) / 2);
		} else if (options.textAlign == "left") {
			return 0;
		} else if (options.textAlign == "right") {
			return Math.floor(textWidth - barcodeWidth);
		}
	}
	return 0;
}

function calculateEncodingAttributes(encodings, barcodeOptions, context) {
	for (var i = 0; i < encodings.length; i++) {
		var encoding = encodings[i];
		var options = (0, _merge2$3.default)(barcodeOptions, encoding.options);

		// Calculate the width of the encoding
		var textWidth;
		if (options.displayValue) {
			textWidth = messureText(encoding.text, options, context);
		} else {
			textWidth = 0;
		}

		var barcodeWidth = encoding.data.length * options.width;
		encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));

		encoding.height = getEncodingHeight(encoding, options);

		encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
	}
}

function getTotalWidthOfEncodings(encodings) {
	var totalWidth = 0;
	for (var i = 0; i < encodings.length; i++) {
		totalWidth += encodings[i].width;
	}
	return totalWidth;
}

function getMaximumHeightOfEncodings(encodings) {
	var maxHeight = 0;
	for (var i = 0; i < encodings.length; i++) {
		if (encodings[i].height > maxHeight) {
			maxHeight = encodings[i].height;
		}
	}
	return maxHeight;
}

function messureText(string, options, context) {
	var ctx;

	if (context) {
		ctx = context;
	} else if (typeof document !== "undefined") {
		ctx = document.createElement("canvas").getContext("2d");
	} else {
		// If the text cannot be messured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;

	// Calculate the width of the encoding
	var measureTextResult = ctx.measureText(string);
	if (!measureTextResult) {
		// Some implementations don't implement measureText and return undefined.
		// If the text cannot be measured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	var size = measureTextResult.width;
	return size;
}

shared.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
shared.getEncodingHeight = getEncodingHeight;
shared.getBarcodePadding = getBarcodePadding;
shared.calculateEncodingAttributes = calculateEncodingAttributes;
shared.getTotalWidthOfEncodings = getTotalWidthOfEncodings;

Object.defineProperty(canvas, "__esModule", {
	value: true
});

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge$2 = merge;

var _merge2$2 = _interopRequireDefault$4(_merge$2);

var _shared$1 = shared;

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasRenderer = function () {
	function CanvasRenderer(canvas, encodings, options) {
		_classCallCheck$4(this, CanvasRenderer);

		this.canvas = canvas;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass$3(CanvasRenderer, [{
		key: "render",
		value: function render() {
			// Abort if the browser does not support HTML5 canvas
			if (!this.canvas.getContext) {
				throw new Error('The browser does not support canvas.');
			}

			this.prepareCanvas();
			for (var i = 0; i < this.encodings.length; i++) {
				var encodingOptions = (0, _merge2$2.default)(this.options, this.encodings[i].options);

				this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
				this.drawCanvasText(encodingOptions, this.encodings[i]);

				this.moveCanvasDrawing(this.encodings[i]);
			}

			this.restoreCanvas();
		}
	}, {
		key: "prepareCanvas",
		value: function prepareCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.save();

			(0, _shared$1.calculateEncodingAttributes)(this.encodings, this.options, ctx);
			var totalWidth = (0, _shared$1.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared$1.getMaximumHeightOfEncodings)(this.encodings);

			this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;

			this.canvas.height = maxHeight;

			// Paint the canvas
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.options.background) {
				ctx.fillStyle = this.options.background;
				ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			}

			ctx.translate(this.options.marginLeft, 0);
		}
	}, {
		key: "drawCanvasBarcode",
		value: function drawCanvasBarcode(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.marginTop + options.fontSize + options.textMargin;
			} else {
				yFrom = options.marginTop;
			}

			ctx.fillStyle = options.lineColor;

			for (var b = 0; b < binary.length; b++) {
				var x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					ctx.fillRect(x, yFrom, options.width, options.height);
				} else if (binary[b]) {
					ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
				}
			}
		}
	}, {
		key: "drawCanvasText",
		value: function drawCanvasText(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var font = options.fontOptions + " " + options.fontSize + "px " + options.font;

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				if (options.textPosition == "top") {
					y = options.marginTop + options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.marginTop + options.fontSize;
				}

				ctx.font = font;

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					ctx.textAlign = 'left';
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					ctx.textAlign = 'right';
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						ctx.textAlign = 'center';
					}

				ctx.fillText(encoding.text, x, y);
			}
		}
	}, {
		key: "moveCanvasDrawing",
		value: function moveCanvasDrawing(encoding) {
			var ctx = this.canvas.getContext("2d");

			ctx.translate(encoding.width, 0);
		}
	}, {
		key: "restoreCanvas",
		value: function restoreCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.restore();
		}
	}]);

	return CanvasRenderer;
}();

canvas.default = CanvasRenderer;

var svg = {};

Object.defineProperty(svg, "__esModule", {
	value: true
});

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge$1 = merge;

var _merge2$1 = _interopRequireDefault$3(_merge$1);

var _shared = shared;

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgns = "http://www.w3.org/2000/svg";

var SVGRenderer = function () {
	function SVGRenderer(svg, encodings, options) {
		_classCallCheck$3(this, SVGRenderer);

		this.svg = svg;
		this.encodings = encodings;
		this.options = options;
		this.document = options.xmlDocument || document;
	}

	_createClass$2(SVGRenderer, [{
		key: "render",
		value: function render() {
			var currentX = this.options.marginLeft;

			this.prepareSVG();
			for (var i = 0; i < this.encodings.length; i++) {
				var encoding = this.encodings[i];
				var encodingOptions = (0, _merge2$1.default)(this.options, encoding.options);

				var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);

				this.setGroupOptions(group, encodingOptions);

				this.drawSvgBarcode(group, encodingOptions, encoding);
				this.drawSVGText(group, encodingOptions, encoding);

				currentX += encoding.width;
			}
		}
	}, {
		key: "prepareSVG",
		value: function prepareSVG() {
			// Clear the SVG
			while (this.svg.firstChild) {
				this.svg.removeChild(this.svg.firstChild);
			}

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			var width = totalWidth + this.options.marginLeft + this.options.marginRight;
			this.setSvgAttributes(width, maxHeight);

			if (this.options.background) {
				this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
			}
		}
	}, {
		key: "drawSvgBarcode",
		value: function drawSvgBarcode(parent, options, encoding) {
			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.fontSize + options.textMargin;
			} else {
				yFrom = 0;
			}

			var barWidth = 0;
			var x = 0;
			for (var b = 0; b < binary.length; b++) {
				x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					barWidth++;
				} else if (barWidth > 0) {
					this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
					barWidth = 0;
				}
			}

			// Last draw is needed since the barcode ends with 1
			if (barWidth > 0) {
				this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
			}
		}
	}, {
		key: "drawSVGText",
		value: function drawSVGText(parent, options, encoding) {
			var textElem = this.document.createElementNS(svgns, 'text');

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);

				if (options.textPosition == "top") {
					y = options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.fontSize;
				}

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					textElem.setAttribute("text-anchor", "start");
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					textElem.setAttribute("text-anchor", "end");
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						textElem.setAttribute("text-anchor", "middle");
					}

				textElem.setAttribute("x", x);
				textElem.setAttribute("y", y);

				textElem.appendChild(this.document.createTextNode(encoding.text));

				parent.appendChild(textElem);
			}
		}
	}, {
		key: "setSvgAttributes",
		value: function setSvgAttributes(width, height) {
			var svg = this.svg;
			svg.setAttribute("width", width + "px");
			svg.setAttribute("height", height + "px");
			svg.setAttribute("x", "0px");
			svg.setAttribute("y", "0px");
			svg.setAttribute("viewBox", "0 0 " + width + " " + height);

			svg.setAttribute("xmlns", svgns);
			svg.setAttribute("version", "1.1");

			svg.setAttribute("style", "transform: translate(0,0)");
		}
	}, {
		key: "createGroup",
		value: function createGroup(x, y, parent) {
			var group = this.document.createElementNS(svgns, 'g');
			group.setAttribute("transform", "translate(" + x + ", " + y + ")");

			parent.appendChild(group);

			return group;
		}
	}, {
		key: "setGroupOptions",
		value: function setGroupOptions(group, options) {
			group.setAttribute("style", "fill:" + options.lineColor + ";");
		}
	}, {
		key: "drawRect",
		value: function drawRect(x, y, width, height, parent) {
			var rect = this.document.createElementNS(svgns, 'rect');

			rect.setAttribute("x", x);
			rect.setAttribute("y", y);
			rect.setAttribute("width", width);
			rect.setAttribute("height", height);

			parent.appendChild(rect);

			return rect;
		}
	}]);

	return SVGRenderer;
}();

svg.default = SVGRenderer;

var object = {};

Object.defineProperty(object, "__esModule", {
	value: true
});

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectRenderer = function () {
	function ObjectRenderer(object, encodings, options) {
		_classCallCheck$2(this, ObjectRenderer);

		this.object = object;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass$1(ObjectRenderer, [{
		key: "render",
		value: function render() {
			this.object.encodings = this.encodings;
		}
	}]);

	return ObjectRenderer;
}();

object.default = ObjectRenderer;

Object.defineProperty(renderers, "__esModule", {
  value: true
});

var _canvas = canvas;

var _canvas2 = _interopRequireDefault$2(_canvas);

var _svg = svg;

var _svg2 = _interopRequireDefault$2(_svg);

var _object = object;

var _object2 = _interopRequireDefault$2(_object);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

renderers.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };

var exceptions = {};

Object.defineProperty(exceptions, "__esModule", {
	value: true
});

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidInputException = function (_Error) {
	_inherits(InvalidInputException, _Error);

	function InvalidInputException(symbology, input) {
		_classCallCheck$1(this, InvalidInputException);

		var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));

		_this.name = "InvalidInputException";

		_this.symbology = symbology;
		_this.input = input;

		_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
		return _this;
	}

	return InvalidInputException;
}(Error);

var InvalidElementException = function (_Error2) {
	_inherits(InvalidElementException, _Error2);

	function InvalidElementException() {
		_classCallCheck$1(this, InvalidElementException);

		var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));

		_this2.name = "InvalidElementException";
		_this2.message = "Not supported type to render on";
		return _this2;
	}

	return InvalidElementException;
}(Error);

var NoElementException = function (_Error3) {
	_inherits(NoElementException, _Error3);

	function NoElementException() {
		_classCallCheck$1(this, NoElementException);

		var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));

		_this3.name = "NoElementException";
		_this3.message = "No element to render on.";
		return _this3;
	}

	return NoElementException;
}(Error);

exceptions.InvalidInputException = InvalidInputException;
exceptions.InvalidElementException = InvalidElementException;
exceptions.NoElementException = NoElementException;

Object.defineProperty(getRenderProperties$1, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
/* global HTMLCanvasElement */
/* global SVGElement */

var _getOptionsFromElement = getOptionsFromElement$1;

var _getOptionsFromElement2 = _interopRequireDefault$1(_getOptionsFromElement);

var _renderers = renderers;

var _renderers2 = _interopRequireDefault$1(_renderers);

var _exceptions$1 = exceptions;

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes an element and returns an object with information about how
// it should be rendered
// This could also return an array with these objects
// {
//   element: The element that the renderer should draw on
//   renderer: The name of the renderer
//   afterRender (optional): If something has to done after the renderer
//     completed, calls afterRender (function)
//   options (optional): Options that can be defined in the element
// }

function getRenderProperties(element) {
	// If the element is a string, query select call again
	if (typeof element === "string") {
		return querySelectedRenderProperties(element);
	}
	// If element is array. Recursivly call with every object in the array
	else if (Array.isArray(element)) {
			var returnArray = [];
			for (var i = 0; i < element.length; i++) {
				returnArray.push(getRenderProperties(element[i]));
			}
			return returnArray;
		}
		// If element, render on canvas and set the uri as src
		else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
				return newCanvasRenderProperties(element);
			}
			// If SVG
			else if (element && element.nodeName && element.nodeName.toLowerCase() === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
					return {
						element: element,
						options: (0, _getOptionsFromElement2.default)(element),
						renderer: _renderers2.default.SVGRenderer
					};
				}
				// If canvas (in browser)
				else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.CanvasRenderer
						};
					}
					// If canvas (in node)
					else if (element && element.getContext) {
							return {
								element: element,
								renderer: _renderers2.default.CanvasRenderer
							};
						} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
							return {
								element: element,
								renderer: _renderers2.default.ObjectRenderer
							};
						} else {
							throw new _exceptions$1.InvalidElementException();
						}
}

function querySelectedRenderProperties(string) {
	var selector = document.querySelectorAll(string);
	if (selector.length === 0) {
		return undefined;
	} else {
		var returnArray = [];
		for (var i = 0; i < selector.length; i++) {
			returnArray.push(getRenderProperties(selector[i]));
		}
		return returnArray;
	}
}

function newCanvasRenderProperties(imgElement) {
	var canvas = document.createElement('canvas');
	return {
		element: canvas,
		options: (0, _getOptionsFromElement2.default)(imgElement),
		renderer: _renderers2.default.CanvasRenderer,
		afterRender: function afterRender() {
			imgElement.setAttribute("src", canvas.toDataURL());
		}
	};
}

getRenderProperties$1.default = getRenderProperties;

var ErrorHandler$1 = {};

Object.defineProperty(ErrorHandler$1, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console: 0 */

var ErrorHandler = function () {
	function ErrorHandler(api) {
		_classCallCheck(this, ErrorHandler);

		this.api = api;
	}

	_createClass(ErrorHandler, [{
		key: "handleCatch",
		value: function handleCatch(e) {
			// If babel supported extending of Error in a correct way instanceof would be used here
			if (e.name === "InvalidInputException") {
				if (this.api._options.valid !== this.api._defaults.valid) {
					this.api._options.valid(false);
				} else {
					throw e.message;
				}
			} else {
				throw e;
			}

			this.api.render = function () {};
		}
	}, {
		key: "wrapBarcodeCall",
		value: function wrapBarcodeCall(func) {
			try {
				var result = func.apply(undefined, arguments);
				this.api._options.valid(true);
				return result;
			} catch (e) {
				this.handleCatch(e);

				return this.api;
			}
		}
	}]);

	return ErrorHandler;
}();

ErrorHandler$1.default = ErrorHandler;

var _barcodes = barcodes;

var _barcodes2 = _interopRequireDefault(_barcodes);

var _merge = merge;

var _merge2 = _interopRequireDefault(_merge);

var _linearizeEncodings = linearizeEncodings$1;

var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);

var _fixOptions = fixOptions$1;

var _fixOptions2 = _interopRequireDefault(_fixOptions);

var _getRenderProperties = getRenderProperties$1;

var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);

var _optionsFromStrings = optionsFromStrings$1;

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _ErrorHandler = ErrorHandler$1;

var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);

var _exceptions = exceptions;

var _defaults = defaults$1;

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The protype of the object returned from the JsBarcode() call


// Help functions
var API = function API() {};

// The first call of the library API
// Will return an object with all barcodes calls and the data that is used
// by the renderers


// Default values


// Exceptions
// Import all the barcodes
var JsBarcode = function JsBarcode(element, text, options) {
	var api = new API();

	if (typeof element === "undefined") {
		throw Error("No element to render on was provided.");
	}

	// Variables that will be pased through the API calls
	api._renderProperties = (0, _getRenderProperties2.default)(element);
	api._encodings = [];
	api._options = _defaults2.default;
	api._errorHandler = new _ErrorHandler2.default(api);

	// If text is set, use the simple syntax (render the barcode directly)
	if (typeof text !== "undefined") {
		options = options || {};

		if (!options.format) {
			options.format = autoSelectBarcode();
		}

		api.options(options)[options.format](text, options).render();
	}

	return api;
};

// To make tests work TODO: remove
JsBarcode.getModule = function (name) {
	return _barcodes2.default[name];
};

// Register all barcodes
for (var name in _barcodes2.default) {
	if (_barcodes2.default.hasOwnProperty(name)) {
		// Security check if the propery is a prototype property
		registerBarcode(_barcodes2.default, name);
	}
}
function registerBarcode(barcodes, name) {
	API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
		var api = this;
		return api._errorHandler.wrapBarcodeCall(function () {
			// Ensure text is options.text
			options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;

			var newOptions = (0, _merge2.default)(api._options, options);
			newOptions = (0, _optionsFromStrings2.default)(newOptions);
			var Encoder = barcodes[name];
			var encoded = encode(text, Encoder, newOptions);
			api._encodings.push(encoded);

			return api;
		});
	};
}

// encode() handles the Encoder call and builds the binary string to be rendered
function encode(text, Encoder, options) {
	// Ensure that text is a string
	text = "" + text;

	var encoder = new Encoder(text, options);

	// If the input is not valid for the encoder, throw error.
	// If the valid callback option is set, call it instead of throwing error
	if (!encoder.valid()) {
		throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
	}

	// Make a request for the binary data (and other infromation) that should be rendered
	var encoded = encoder.encode();

	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	encoded = (0, _linearizeEncodings2.default)(encoded);

	// Merge
	for (var i = 0; i < encoded.length; i++) {
		encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
	}

	return encoded;
}

function autoSelectBarcode() {
	// If CODE128 exists. Use it
	if (_barcodes2.default["CODE128"]) {
		return "CODE128";
	}

	// Else, take the first (probably only) barcode
	return Object.keys(_barcodes2.default)[0];
}

// Sets global encoder options
// Added to the api by the JsBarcode function
API.prototype.options = function (options) {
	this._options = (0, _merge2.default)(this._options, options);
	return this;
};

// Will create a blank space (usually in between barcodes)
API.prototype.blank = function (size) {
	var zeroes = new Array(size + 1).join("0");
	this._encodings.push({ data: zeroes });
	return this;
};

// Initialize JsBarcode on all HTML elements defined.
API.prototype.init = function () {
	// Should do nothing if no elements where found
	if (!this._renderProperties) {
		return;
	}

	// Make sure renderProperies is an array
	if (!Array.isArray(this._renderProperties)) {
		this._renderProperties = [this._renderProperties];
	}

	var renderProperty;
	for (var i in this._renderProperties) {
		renderProperty = this._renderProperties[i];
		var options = (0, _merge2.default)(this._options, renderProperty.options);

		if (options.format == "auto") {
			options.format = autoSelectBarcode();
		}

		this._errorHandler.wrapBarcodeCall(function () {
			var text = options.value;
			var Encoder = _barcodes2.default[options.format.toUpperCase()];
			var encoded = encode(text, Encoder, options);

			render(renderProperty, encoded, options);
		});
	}
};

// The render API call. Calls the real render function.
API.prototype.render = function () {
	if (!this._renderProperties) {
		throw new _exceptions.NoElementException();
	}

	if (Array.isArray(this._renderProperties)) {
		for (var i = 0; i < this._renderProperties.length; i++) {
			render(this._renderProperties[i], this._encodings, this._options);
		}
	} else {
		render(this._renderProperties, this._encodings, this._options);
	}

	return this;
};

API.prototype._defaults = _defaults2.default;

// Prepares the encodings and calls the renderer
function render(renderProperties, encodings, options) {
	encodings = (0, _linearizeEncodings2.default)(encodings);

	for (var i = 0; i < encodings.length; i++) {
		encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
		(0, _fixOptions2.default)(encodings[i].options);
	}

	(0, _fixOptions2.default)(options);

	var Renderer = renderProperties.renderer;
	var renderer = new Renderer(renderProperties.element, encodings, options);
	renderer.render();

	if (renderProperties.afterRender) {
		renderProperties.afterRender();
	}
}

// Export to browser
if (typeof window !== "undefined") {
	window.JsBarcode = JsBarcode;
}

// Export to jQuery
/*global jQuery */
if (typeof jQuery !== 'undefined') {
	jQuery.fn.JsBarcode = function (content, options) {
		var elementArray = [];
		jQuery(this).each(function () {
			elementArray.push(this);
		});
		return JsBarcode(elementArray, content, options);
	};
}

// Export to commonJS
var JsBarcode_1 = JsBarcode;

var jsBarcode = /*@__PURE__*/getDefaultExportFromCjs(JsBarcode_1);

class PrintCanvasRenderer {
    constructor(config) {
        this.currentY = 0;
        this.config = {
            width: 58,
            marginLeft: 0,
            marginTop: 0,
            marginRight: 0,
            marginBottom: 0,
            printMode: 'bmp',
            rotate: 0,
            type: 'receipt',
            feedLines: 0,
            connMethod: 'integrated',
            showCutPaper: true,
            showBoundsLine: true
        };
        this.mmToPx = 8; // 1mm = 3.78px (96dpi)
        this.defaultLineSpace = 0.5; // 1mm = 3.78px (96dpi)
        this.config = {
            ...this.config,
            ...config
        };
        if (this.config.type === 'label') {
            PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM = 2;
        }
        if (this.config.type === 'receipt') {
            if (this.config.width === 58) {
                PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM = 5;
            }
            if (this.config.width === 80) {
                PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM = 4;
            }
        }
        // 计算Canvas尺寸
        this.config.height ? this.mmToPx * this.config.height : 4000; // 默认高度;
        const widthPx = this.mmToPx * this.config.width || 60;
        this.canvas = document.createElement('canvas');
        this.canvas.width = widthPx;
        this.canvas.height = 4000;
        this.ctx = this.canvas.getContext('2d');
        this.ctx.fillStyle = 'white';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = 'black';
        // 设置初始位置
        this.currentY = this.mmToPx * (this.config.marginTop || 0);
    }
    // 主渲染方法
    async render(commands) {
        var _a, _b, _c, _d, _e;
        // 第一次渲染用于计算高度
        const tempCanvas = document.createElement('canvas');
        tempCanvas.width = this.canvas.width;
        tempCanvas.height = 4000; // 临时高度
        const tempCtx = tempCanvas.getContext('2d');
        tempCtx.fillStyle = 'white';
        tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
        tempCtx.fillStyle = 'black';
        // 保存原始上下文
        const originalCtx = this.ctx;
        const originalY = this.currentY;
        // 使用临时上下文进行第一次渲染
        this.ctx = tempCtx;
        this.currentY = this.mmToPx * (this.config.marginTop || 0);
        // 记录所有内容的底部y坐标
        let maxContentBottom = this.currentY;
        // 渲染所有命令
        for (const command of commands) {
            switch (command.type) {
                case 'text':
                    if (command === null || command === void 0 ? void 0 : command.params) {
                        // 记录渲染前y
                        this.currentY;
                        await this.renderText(command.params);
                        // 计算内容底部y
                        let textBottom = this.currentY;
                        if (command.params.y !== undefined) {
                            // y定位，需用y+内容高度
                            const fontSize = command.params.size || 22;
                            const lineSpace = (command.params.lineSpace || this.defaultLineSpace); // 单位mm
                            let value = command.params.value || '';
                            let lines = value.split('\n').length;
                            const baseLineHeight = fontSize * 1.2;
                            const lineHeight = baseLineHeight + lineSpace * this.mmToPx;
                            textBottom = command.params.y * this.mmToPx + fontSize + (lines - 1) * lineHeight;
                        }
                        if (textBottom > maxContentBottom)
                            maxContentBottom = textBottom;
                    }
                    break;
                case 'columns':
                    this.currentY;
                    await this.renderColumns(command.params);
                    let columnsBottom = this.currentY;
                    if (command.params.y !== undefined) {
                        const items = command.params.items || [];
                        const fontSize = ((_a = items[0]) === null || _a === void 0 ? void 0 : _a.size) || 22;
                        const lineSpace = (command.params.lineSpace || this.defaultLineSpace); // 单位mm
                        let maxLines = 1;
                        for (const item of items) {
                            let value = item.value || '';
                            let lines = value.split('\n').length;
                            if (lines > maxLines)
                                maxLines = lines;
                        }
                        const baseLineHeight = fontSize * 1.2;
                        const lineHeight = baseLineHeight + lineSpace * this.mmToPx;
                        columnsBottom = command.params.y * this.mmToPx + fontSize + (maxLines - 1) * lineHeight;
                    }
                    if (columnsBottom > maxContentBottom)
                        maxContentBottom = columnsBottom;
                    break;
                case 'image':
                    this.currentY;
                    await this.renderImage(command.params);
                    let imageBottom = this.currentY;
                    if (command.params.y !== undefined) {
                        // 估算图片高度，假设图片高度未知，暂用50px
                        const imgY = command.params.y * this.mmToPx;
                        const imgHeight = 50;
                        imageBottom = imgY + imgHeight;
                    }
                    if (imageBottom > maxContentBottom)
                        maxContentBottom = imageBottom;
                    break;
                case 'qrcode':
                    this.currentY;
                    await this.renderQRCode(command.params);
                    let qrBottom = this.currentY;
                    if (command.params.y !== undefined) {
                        const size = command.params.size || 9;
                        const qrY = command.params.y * this.mmToPx;
                        const qrHeight = size * 3 * this.mmToPx;
                        qrBottom = qrY + qrHeight;
                    }
                    if (qrBottom > maxContentBottom)
                        maxContentBottom = qrBottom;
                    break;
                case 'barcode':
                    this.currentY;
                    await this.renderBarcode(command.params);
                    let barcodeBottom = this.currentY;
                    if (command.params.y !== undefined) {
                        const barcodeY = command.params.y * this.mmToPx;
                        const barcodeHeight = (command.params.height || 5) * this.mmToPx;
                        let hri = command.params.hri === 1 ? 1 : 0;
                        let hriSize = command.params.hriSize || 18;
                        let totalHeight = barcodeHeight;
                        if (hri === 1)
                            totalHeight += hriSize + 8;
                        barcodeBottom = barcodeY + totalHeight;
                    }
                    if (barcodeBottom > maxContentBottom)
                        maxContentBottom = barcodeBottom;
                    break;
                case 'dividing':
                    this.renderDividing(command.params);
                    let dividingBottom = this.currentY;
                    if (command.params.y !== undefined) {
                        const dividingY = command.params.y * this.mmToPx;
                        dividingBottom = dividingY + 2; // 2px分割线高度
                    }
                    if (dividingBottom > maxContentBottom)
                        maxContentBottom = dividingBottom;
                    break;
                case 'cutPaper':
                    this.renderCutPaper();
                    if (this.currentY > maxContentBottom)
                        maxContentBottom = this.currentY;
                    break;
            }
        }
        // 计算实际内容高度，取currentY和所有内容底部最大值
        const contentHeight = Math.max(this.currentY, maxContentBottom) + this.mmToPx * (this.config.marginBottom || 0);
        // 重新设置canvas高度
        // 当为标签打印且显式关闭 showBoundsLine 时，仅渲染到设定高度，不再扩展
        if (this.config.type === 'label' && this.config.height) {
            if (this.config.showBoundsLine === false) {
                this.canvas.height = this.mmToPx * this.config.height;
            }
            else {
                // 默认行为：保证至少等于label高度
                this.canvas.height = Math.max(contentHeight, this.mmToPx * this.config.height);
            }
        }
        else {
            this.canvas.height = contentHeight;
        }
        // 恢复原始上下文
        this.ctx = originalCtx;
        this.currentY = originalY;
        // 重新填充背景
        this.ctx.fillStyle = 'white';
        this.ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.fillStyle = 'black';
        // 重新渲染所有内容
        // 若为标签并且 showBoundsLine === false，则裁剪到设定高度，防止渲染超出区域
        const needClipToHeight = this.config.type === 'label' && this.config.height && this.config.showBoundsLine === false;
        if (needClipToHeight) {
            this.ctx.save();
            this.ctx.beginPath();
            this.ctx.rect(0, 0, this.canvas.width, this.mmToPx * this.config.height);
            this.ctx.clip();
        }
        for (const command of commands) {
            switch (command.type) {
                case 'text':
                    await this.renderText(command.params);
                    break;
                case 'columns':
                    await this.renderColumns(command.params);
                    break;
                case 'image':
                    await this.renderImage(command.params);
                    break;
                case 'qrcode':
                    await this.renderQRCode(command.params);
                    break;
                case 'barcode':
                    await this.renderBarcode(command.params);
                    break;
                case 'dividing':
                    this.renderDividing(command.params);
                    break;
                case 'cutPaper':
                    this.renderCutPaper();
                    break;
            }
        }
        if (needClipToHeight) {
            this.ctx.restore();
        }
        // 新增：如果type是label且有height，且开启showBoundsLine，画一条虚线表示界外
        if (this.config.showBoundsLine !== false && this.config.type === 'label' && this.config.height) {
            this.renderOutOfBoundsLine();
        }
        // 新增：生成图片后，增加 feedLines 个空行（走纸）
        const feedLines = typeof this.config.feedLines === 'number' ? this.config.feedLines : 0;
        // 只有外置小票才会走纸
        if (feedLines > 0 && this.config.type === 'receipt' && this.config.connMethod !== 'integrated') {
            const fontSize = ((_c = (_b = commands.find(cmd => cmd.type === 'text')) === null || _b === void 0 ? void 0 : _b.params) === null || _c === void 0 ? void 0 : _c.size) || 22;
            const lineSpace = ((_e = (_d = commands.find(cmd => cmd.type === 'text')) === null || _d === void 0 ? void 0 : _d.params) === null || _e === void 0 ? void 0 : _e.lineSpace) || this.defaultLineSpace;
            const baseLineHeight = fontSize * 1.2;
            const blankLineHeight = baseLineHeight + lineSpace * this.mmToPx;
            const oldHeight = this.canvas.height;
            const newHeight = oldHeight + feedLines * blankLineHeight;
            // 创建离屏canvas
            const tempCanvas = document.createElement('canvas');
            tempCanvas.width = this.canvas.width;
            tempCanvas.height = newHeight;
            const tempCtx = tempCanvas.getContext('2d');
            // 先填充白色背景
            tempCtx.fillStyle = 'white';
            tempCtx.fillRect(0, 0, tempCanvas.width, tempCanvas.height);
            // 复制原内容
            tempCtx.drawImage(this.canvas, 0, 0);
            // 替换原canvas
            this.canvas.height = newHeight;
            this.ctx = this.canvas.getContext('2d');
            this.ctx.drawImage(tempCanvas, 0, 0);
        }
        // 处理旋转逻辑，只支持0和180，非180都按0
        const rotate = this.config.rotate === 180 ? 180 : 0;
        if (rotate === 180 && this.config.type === 'label') {
            // 创建一个新的canvas用于旋转
            const rotatedCanvas = document.createElement('canvas');
            rotatedCanvas.width = this.canvas.width;
            rotatedCanvas.height = this.canvas.height;
            const rotatedCtx = rotatedCanvas.getContext('2d');
            // 平移到中心，旋转，再平移回来
            rotatedCtx.translate(rotatedCanvas.width / 2, rotatedCanvas.height / 2);
            rotatedCtx.rotate(Math.PI);
            rotatedCtx.drawImage(this.canvas, -this.canvas.width / 2, -this.canvas.height / 2);
            return rotatedCanvas.toDataURL('image/png');
        }
        return this.canvas.toDataURL('image/png');
    }
    // 获取最终的Canvas
    getCanvas() {
        return this.canvas;
    }
    // 渲染文本
    async renderText(params) {
        var _a;
        if (!params)
            return;
        const ctx = this.ctx;
        const fontSize = params.size || 22;
        const marginTop = (params.marginTop || 0) * this.mmToPx;
        const marginBottom = (params.marginBottom || 0) * this.mmToPx;
        const lineSpace = (params.lineSpace || this.defaultLineSpace); // 单位mm
        const maxLines = params.maxLines && params.maxLines > 0 ? Math.min(params.maxLines, 255) : 0;
        // 新规则：默认行高 fontSize*1.2，如果有 lineSpace，则行高为 fontSize*1.2 + lineSpace * this.mmToPx
        const baseLineHeight = fontSize * 1.2;
        const lineHeight = baseLineHeight + lineSpace * this.mmToPx;
        // 处理y
        let y;
        if (params.y !== undefined) {
            y = params.y * this.mmToPx;
        }
        else {
            this.currentY += marginTop;
            y = this.currentY;
        }
        // 设置字体
        ctx.font = `${params.bold ? 'bold ' : ''}${fontSize}px Arial, 'Noto Sans Khmer', 'Khmer UI', 'Noto Sans', 'Segoe UI', sans-serif`;
        // 计算可用宽度，左右默认边距始终生效
        let defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
        const availableWidth = this.canvas.width -
            (defaultSideMarginPx * 2) -
            this.mmToPx * ((params.marginLeft || 0) + (params.marginRight || 0) +
                (this.config.marginLeft + (((_a = this === null || this === void 0 ? void 0 : this.config) === null || _a === void 0 ? void 0 : _a.marginRight) || 0)));
        // 自动换行处理
        // 新换行规则：英文按单词换行，网址整体视为一个单词，中文按字换行，日期和时间各自整体视为一个token，允许在它们之间的空格处分行
        const urlRegex = /https?:\/\/[\w\-\.\/?#&=:%]+/g;
        const dateRegex = /\d{4}[\/-]\d{2}[\/-]\d{2}/g;
        const timeRegex = /\d{2}:\d{2}(?::\d{2})?/g;
        let tokens = [];
        let value = params.value;
        // 先识别所有网址、日期、时间
        let matchArr = [];
        let match;
        while ((match = urlRegex.exec(value)) !== null) {
            matchArr.push({ index: match.index, value: match[0], type: 'url' });
        }
        while ((match = dateRegex.exec(value)) !== null) {
            matchArr.push({ index: match.index, value: match[0], type: 'date' });
        }
        while ((match = timeRegex.exec(value)) !== null) {
            matchArr.push({ index: match.index, value: match[0], type: 'time' });
        }
        // 按出现顺序排序
        matchArr.sort((a, b) => a.index - b.index);
        let cur = 0;
        for (let i = 0; i < matchArr.length; i++) {
            const m = matchArr[i];
            if (m.index > cur) {
                // 处理前面的内容
                const part = value.substring(cur, m.index);
                tokens.push(...part.split(/([\u4e00-\u9fa5])/).filter(Boolean).flatMap(token => {
                    if (/^[\u4e00-\u9fa5]$/.test(token))
                        return [token];
                    // 英文及其它按单词
                    return token.split(/(\s+|\b)/).filter(Boolean);
                }));
            }
            tokens.push(m.value);
            cur = m.index + m.value.length;
        }
        if (cur < value.length) {
            const part = value.substring(cur);
            tokens.push(...part.split(/([\u4e00-\u9fa5])/).filter(Boolean).flatMap(token => {
                if (/^[\u4e00-\u9fa5]$/.test(token))
                    return [token];
                return token.split(/(\s+|\b)/).filter(Boolean);
            }));
        }
        const lines = [];
        let currentLine = '';
        let lineCount = 0;
        for (let i = 0; i < tokens.length; i++) {
            const token = tokens[i];
            // 如果是空格直接加
            if (/^\s+$/.test(token)) {
                currentLine += token;
                continue;
            }
            const testLine = currentLine ? currentLine + token : token;
            const testWidth = ctx.measureText(testLine).width;
            if (testWidth > availableWidth && currentLine.length > 0) {
                if (maxLines === 1) {
                    // 单行模式下，在当前行末尾添加省略号
                    while (currentLine.length > 0 && ctx.measureText(currentLine + '...').width > availableWidth) {
                        currentLine = currentLine.slice(0, -1);
                    }
                    currentLine += '...';
                    lines.push(currentLine);
                    break;
                }
                else {
                    lineCount++;
                    if (maxLines > 0 && lineCount >= maxLines) {
                        // 在最后一行末尾添加省略号
                        while (currentLine.length > 0 && ctx.measureText(currentLine + '...').width > availableWidth) {
                            currentLine = currentLine.slice(0, -1);
                        }
                        currentLine += '...';
                        lines.push(currentLine);
                        break;
                    }
                    else {
                        lines.push(currentLine.trimEnd());
                        currentLine = token;
                    }
                }
            }
            else {
                currentLine = testLine;
            }
        }
        // 只在非单行模式下添加最后一行
        if (currentLine && (maxLines === 0 || lineCount < maxLines) && maxLines !== 1) {
            lines.push(currentLine.trimEnd());
        }
        // 绘制文本行
        for (const lineText of lines) {
            let x = params.x !== undefined
                ? params.x * this.mmToPx
                : defaultSideMarginPx + this.mmToPx * (this.config.marginLeft + (params.marginLeft || 0));
            // 处理对齐方式
            if (params.align === 1) { // 居中
                const lineWidth = ctx.measureText(lineText).width;
                x = (this.canvas.width - lineWidth) / 2;
            }
            else if (params.align === 2) { // 右对齐
                x = this.canvas.width - defaultSideMarginPx - this.mmToPx * (this.config.marginRight + (params.marginRight || 0)) - ctx.measureText(lineText).width;
            }
            // 计算文本基线位置，使文本在行高中垂直居中
            const baselineOffset = (lineHeight - fontSize) / 2;
            ctx.fillText(lineText, x, y + fontSize + baselineOffset);
            y += lineHeight;
        }
        if (params.y === undefined) {
            this.currentY = y + marginBottom;
        }
    }
    // 渲染多列文本
    async renderColumns(params) {
        var _a;
        // 若包含 rows（仅支持一层，列内多行），使用块级渲染
        const hasNestedRows = Array.isArray(params === null || params === void 0 ? void 0 : params.items) && params.items.some((it) => it && it.type === 'rows');
        if (hasNestedRows) {
            await this.renderColumnsBlock(params);
            return;
        }
        const marginTop = (params.marginTop || 0) * this.mmToPx;
        const marginBottom = (params.marginBottom || 0) * this.mmToPx;
        const lineSpace = (params.lineSpace || this.defaultLineSpace); // 单位mm
        // 计算总权重和可用宽度，左右默认边距始终生效
        let defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
        // 处理y
        let y;
        if (params.y !== undefined) {
            y = defaultSideMarginPx + this.mmToPx * (this.config.marginTop || 0) + params.y * this.mmToPx;
        }
        else {
            this.currentY += marginTop;
            y = this.currentY;
        }
        const totalWeight = params.items.reduce((sum, item) => sum + (item.weight || 1), 0);
        const availableWidth = this.canvas.width - (defaultSideMarginPx * 2) - this.mmToPx * (this.config.marginLeft + (((_a = this === null || this === void 0 ? void 0 : this.config) === null || _a === void 0 ? void 0 : _a.marginRight) || 0));
        // 计算每单位权重的宽度
        const unitWidth = availableWidth / totalWeight;
        let startX = params.x !== undefined
            ? defaultSideMarginPx + this.mmToPx * this.config.marginLeft + params.x * this.mmToPx
            : defaultSideMarginPx + this.mmToPx * this.config.marginLeft;
        // 1. 先计算每列的换行文本数组和最大行数
        const columnLines = [];
        let maxLineCount = 1;
        const lineHeights = [];
        for (let colIdx = 0; colIdx < params.items.length; colIdx++) {
            const item = params.items[colIdx];
            const itemType = item.type || 'text';
            const itemWidth = unitWidth * (item.weight || 1);
            if (itemType === 'text') {
                const fontSize = item.size || 22;
                const baseLineHeight = fontSize * 1.2;
                const itemLineHeight = baseLineHeight + lineSpace * this.mmToPx;
                lineHeights[colIdx] = itemLineHeight;
                this.ctx.font = `${fontSize}px Arial`;
                // 判断是否为网址
                const urlRegex = /https?:\/\/[\w\-\.\/?#&=:%]+/g;
                let tokens = [];
                let lastIndex = 0;
                let match;
                let value = item.value;
                while ((match = urlRegex.exec(value)) !== null) {
                    if (match.index > lastIndex) {
                        const part = value.substring(lastIndex, match.index);
                        tokens.push(...part.split(/([\u4e00-\u9fa5])/).filter(Boolean).flatMap(token => {
                            if (/^[\u4e00-\u9fa5]$/.test(token))
                                return [token];
                            return token.split(/(\s+|\b)/).filter(Boolean);
                        }));
                    }
                    tokens.push(match[0]);
                    lastIndex = match.index + match[0].length;
                }
                if (lastIndex < value.length) {
                    const part = value.substring(lastIndex);
                    tokens.push(...part.split(/([\u4e00-\u9fa5])/).filter(Boolean).flatMap(token => {
                        if (/^[\u4e00-\u9fa5]$/.test(token))
                            return [token];
                        return token.split(/(\s+|\b)/).filter(Boolean);
                    }));
                }
                // tokens 现在是单词/网址/空格/汉字
                let currentLine = '';
                const lines = [];
                for (let i = 0; i < tokens.length; i++) {
                    const token = tokens[i];
                    // 如果是空格直接加
                    if (/^\s+$/.test(token)) {
                        currentLine += token;
                        continue;
                    }
                    const testLine = currentLine ? currentLine + token : token;
                    const testWidth = this.ctx.measureText(testLine).width;
                    if (testWidth > itemWidth && currentLine.length > 0) {
                        lines.push(currentLine.trimEnd());
                        currentLine = token;
                    }
                    else {
                        currentLine = testLine;
                    }
                }
                if (currentLine)
                    lines.push(currentLine.trimEnd());
                columnLines.push(lines);
                if (lines.length > maxLineCount)
                    maxLineCount = lines.length;
            }
            else {
                // 预加载图片尺寸用于计算本列高度
                let drawH = 0;
                const v = String((item === null || item === void 0 ? void 0 : item.value) || '').trim();
                if (v) {
                    try {
                        const size = await this.getImageNaturalSize(v);
                        if (size) {
                            let drawWidth = size.width;
                            let drawHeight = size.height;
                            if (drawWidth > itemWidth) {
                                const ratio = itemWidth / drawWidth;
                                drawWidth = itemWidth;
                                drawHeight = drawHeight * ratio;
                            }
                            drawH = drawHeight;
                        }
                    }
                    catch { }
                }
                lineHeights[colIdx] = drawH;
                columnLines.push(['[image]']);
            }
        }
        // 2. 逐行渲染
        for (let lineIdx = 0; lineIdx < maxLineCount; lineIdx++) {
            let colStartX = startX;
            for (let colIdx = 0; colIdx < params.items.length; colIdx++) {
                const item = params.items[colIdx];
                const itemType = item.type || 'text';
                const itemWidth = unitWidth * (item.weight || 1);
                if (itemType === 'text') {
                    const fontSize = item.size || 22;
                    const itemLineHeight = fontSize + lineSpace * this.mmToPx;
                    this.ctx.font = `${fontSize}px Arial`;
                    const lineText = columnLines[colIdx][lineIdx] || '';
                    let x = colStartX;
                    if (item.align === 1) { // 居中
                        const textWidth = this.ctx.measureText(lineText).width;
                        x = colStartX + (itemWidth - textWidth) / 2;
                    }
                    else if (item.align === 2) { // 右对齐
                        const textWidth = this.ctx.measureText(lineText).width;
                        x = colStartX + itemWidth - textWidth;
                    }
                    const baselineOffset = (itemLineHeight - fontSize) / 2;
                    this.ctx.fillText(lineText, x, y + fontSize + baselineOffset + lineIdx * itemLineHeight);
                }
                else if (itemType === 'image' && lineIdx === 0) {
                    // 只在第一行渲染图片
                    await new Promise((resolve, reject) => {
                        const img = new Image();
                        if ((item === null || item === void 0 ? void 0 : item.value) && item.value.startsWith('http')) {
                            img.crossOrigin = 'anonymous';
                        }
                        img.onload = () => {
                            let drawWidth = img.width;
                            let drawHeight = img.height;
                            if (drawWidth > itemWidth) {
                                const ratio = itemWidth / drawWidth;
                                drawWidth = itemWidth;
                                drawHeight = drawHeight * ratio;
                            }
                            let x = colStartX;
                            if (item.align === 1) {
                                x = colStartX + (itemWidth - drawWidth) / 2;
                            }
                            else if (item.align === 2) {
                                x = colStartX + itemWidth - drawWidth;
                            }
                            const imgY = y + (lineHeights[colIdx] - drawHeight) / 2;
                            this.ctx.drawImage(img, x, imgY, drawWidth, drawHeight);
                            resolve();
                        };
                        img.onerror = () => resolve();
                        const v = String((item === null || item === void 0 ? void 0 : item.value) || '').trim();
                        if (!v) {
                            resolve();
                            return;
                        }
                        if (v.startsWith('data:') || v.startsWith('http:') || v.startsWith('https:')) {
                            img.src = v;
                        }
                        else if (/^[A-Za-z0-9+/=]+$/.test(v)) {
                            img.src = `data:image/png;base64,${v}`;
                        }
                        else {
                            resolve();
                        }
                    });
                }
                colStartX += itemWidth;
            }
        }
        if (params.y === undefined) {
            // 取所有列的最大行高（包含图片的高度）
            const maxLineHeight = Math.max(...lineHeights.filter(h => h > 0));
            this.currentY = y + maxLineCount * maxLineHeight + marginBottom;
        }
    }
    // 在限定区域内渲染 columns（不叠加默认左右边距），返回渲染结束的 y 值
    async renderColumnsInBox(params, startX, startY, boxWidth) {
        var _a;
        const lineSpace = (params.lineSpace || this.defaultLineSpace);
        const totalWeight = params.items.reduce((sum, item) => sum + ((item === null || item === void 0 ? void 0 : item.weight) || 1), 0);
        const unitWidth = boxWidth / totalWeight;
        const columnLines = [];
        let maxLineCount = 1;
        const lineHeights = [];
        for (let colIdx = 0; colIdx < params.items.length; colIdx++) {
            const item = params.items[colIdx];
            const itemType = (item === null || item === void 0 ? void 0 : item.type) || 'text';
            const itemWidth = unitWidth * ((item === null || item === void 0 ? void 0 : item.weight) || 1);
            if (itemType === 'text') {
                const fontSize = (item === null || item === void 0 ? void 0 : item.size) || 22;
                const baseLineHeight = fontSize * 1.2;
                const itemLineHeight = baseLineHeight + lineSpace * this.mmToPx;
                lineHeights[colIdx] = itemLineHeight;
                this.ctx.font = `${fontSize}px Arial`;
                const lines = this.wrapTextToWidth(String((_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : ''), itemWidth);
                columnLines.push(lines);
                if (lines.length > maxLineCount)
                    maxLineCount = lines.length;
            }
            else {
                // 预加载图片尺寸，确保行高包含图片高度
                let drawH = 0;
                const v = String((item === null || item === void 0 ? void 0 : item.value) || '').trim();
                if (v) {
                    try {
                        const size = await this.getImageNaturalSize(v);
                        if (size) {
                            let drawWidth = size.width;
                            let drawHeight = size.height;
                            if (drawWidth > itemWidth) {
                                const ratio = itemWidth / drawWidth;
                                drawWidth = itemWidth;
                                drawHeight = drawHeight * ratio;
                            }
                            drawH = drawHeight;
                        }
                    }
                    catch { }
                }
                lineHeights[colIdx] = drawH;
                columnLines.push(['[image]']);
            }
        }
        for (let lineIdx = 0; lineIdx < maxLineCount; lineIdx++) {
            let colStartX = startX;
            for (let colIdx = 0; colIdx < params.items.length; colIdx++) {
                const item = params.items[colIdx];
                const itemType = (item === null || item === void 0 ? void 0 : item.type) || 'text';
                const itemWidth = unitWidth * ((item === null || item === void 0 ? void 0 : item.weight) || 1);
                if (itemType === 'text') {
                    const fontSize = (item === null || item === void 0 ? void 0 : item.size) || 22;
                    const itemLineHeight = fontSize + lineSpace * this.mmToPx;
                    this.ctx.font = `${fontSize}px Arial`;
                    const lineText = (columnLines[colIdx][lineIdx] || '');
                    let x = colStartX;
                    if ((item === null || item === void 0 ? void 0 : item.align) === 1) {
                        const textWidth = this.ctx.measureText(lineText).width;
                        x = colStartX + (itemWidth - textWidth) / 2;
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.align) === 2) {
                        const textWidth = this.ctx.measureText(lineText).width;
                        x = colStartX + itemWidth - textWidth;
                    }
                    const baselineOffset = (itemLineHeight - fontSize) / 2;
                    this.ctx.fillText(lineText, x, startY + fontSize + baselineOffset + lineIdx * itemLineHeight);
                }
                else if (itemType === 'image' && lineIdx === 0) {
                    await new Promise((resolve) => {
                        const img = new Image();
                        if (String((item === null || item === void 0 ? void 0 : item.value) || '').startsWith('http'))
                            img.crossOrigin = 'anonymous';
                        img.onload = () => {
                            let drawWidth = img.width;
                            let drawHeight = img.height;
                            if (drawWidth > itemWidth) {
                                const ratio = itemWidth / drawWidth;
                                drawWidth = itemWidth;
                                drawHeight = drawHeight * ratio;
                            }
                            let x = colStartX;
                            if ((item === null || item === void 0 ? void 0 : item.align) === 1)
                                x = colStartX + (itemWidth - drawWidth) / 2;
                            else if ((item === null || item === void 0 ? void 0 : item.align) === 2)
                                x = colStartX + itemWidth - drawWidth;
                            const imgY = startY + (lineHeights[colIdx] - drawHeight) / 2;
                            this.ctx.drawImage(img, x, imgY, drawWidth, drawHeight);
                            resolve();
                        };
                        img.onerror = () => resolve();
                        const v = String((item === null || item === void 0 ? void 0 : item.value) || '');
                        if (v.startsWith('data:') || v.startsWith('http:') || v.startsWith('https:'))
                            img.src = v;
                        else if (/^[A-Za-z0-9+/=]+$/.test(v))
                            img.src = `data:image/png;base64,${v}`;
                    });
                }
                colStartX += itemWidth;
            }
        }
        if (maxLineCount === 0)
            return startY;
        const maxLineHeight = Math.max(...lineHeights.filter(h => h > 0), 0);
        return startY + maxLineCount * (maxLineHeight || 0);
    }
    // 文本按宽度换行（英文按词、中文按字、URL整体）
    wrapTextToWidth(value, widthPx) {
        const urlRegex = /https?:\/\/[\w\-\.\/?#&=:%]+/g;
        let tokens = [];
        let lastIndex = 0;
        let match;
        while ((match = urlRegex.exec(value)) !== null) {
            if (match.index > lastIndex) {
                const part = value.substring(lastIndex, match.index);
                tokens.push(...part.split(/([\u4e00-\u9fa5])/).filter(Boolean).flatMap(token => {
                    if (/^[\u4e00-\u9fa5]$/.test(token))
                        return [token];
                    return token.split(/(\s+|\b)/).filter(Boolean);
                }));
            }
            tokens.push(match[0]);
            lastIndex = match.index + match[0].length;
        }
        if (lastIndex < value.length) {
            const part = value.substring(lastIndex);
            tokens.push(...part.split(/([\u4e00-\u9fa5])/).filter(Boolean).flatMap(token => {
                if (/^[\u4e00-\u9fa5]$/.test(token))
                    return [token];
                return token.split(/(\s+|\b)/).filter(Boolean);
            }));
        }
        const lines = [];
        let currentLine = '';
        for (let i = 0; i < tokens.length; i++) {
            const token = tokens[i];
            if (/^\s+$/.test(token)) {
                currentLine += token;
                continue;
            }
            const testLine = currentLine ? currentLine + token : token;
            const testWidth = this.ctx.measureText(testLine).width;
            if (testWidth > widthPx && currentLine.length > 0) {
                lines.push(currentLine.trimEnd());
                currentLine = token;
            }
            else {
                currentLine = testLine;
            }
        }
        if (currentLine)
            lines.push(currentLine.trimEnd());
        return lines;
    }
    // 预加载图片，返回自然尺寸
    getImageNaturalSize(src) {
        return new Promise((resolve) => {
            const img = new Image();
            if (src.startsWith('http'))
                img.crossOrigin = 'anonymous';
            img.onload = () => {
                resolve({ width: img.width, height: img.height });
            };
            img.onerror = () => resolve(null);
            if (src.startsWith('data:') || src.startsWith('http:') || src.startsWith('https:')) {
                img.src = src;
            }
            else if (/^[A-Za-z0-9+/=]+$/.test(src)) {
                img.src = `data:image/png;base64,${src}`;
            }
            else {
                resolve(null);
            }
        });
    }
    // 块级多列渲染（支持列内 rows，多行，仅一层 columns 嵌套）
    async renderColumnsBlock(params) {
        var _a, _b, _c, _d, _e, _f, _g;
        const marginTop = (params.marginTop || 0) * this.mmToPx;
        const marginBottom = (params.marginBottom || 0) * this.mmToPx;
        const lineSpace = (params.lineSpace || this.defaultLineSpace);
        const defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
        let y;
        if (params.y !== undefined) {
            y = defaultSideMarginPx + this.mmToPx * (this.config.marginTop || 0) + params.y * this.mmToPx;
        }
        else {
            this.currentY += marginTop;
            y = this.currentY;
        }
        const totalWeight = params.items.reduce((sum, item) => sum + ((item === null || item === void 0 ? void 0 : item.weight) || 1), 0);
        const availableWidth = this.canvas.width - (defaultSideMarginPx * 2) - this.mmToPx * (this.config.marginLeft + (((_a = this === null || this === void 0 ? void 0 : this.config) === null || _a === void 0 ? void 0 : _a.marginRight) || 0));
        const unitWidth = availableWidth / totalWeight;
        let startX = params.x !== undefined
            ? defaultSideMarginPx + this.mmToPx * this.config.marginLeft + params.x * this.mmToPx
            : defaultSideMarginPx + this.mmToPx * this.config.marginLeft;
        const columnHeights = [];
        for (let colIdx = 0; colIdx < params.items.length; colIdx++) {
            const item = params.items[colIdx];
            const itemType = (item === null || item === void 0 ? void 0 : item.type) || 'text';
            const colWidth = unitWidth * ((item === null || item === void 0 ? void 0 : item.weight) || 1);
            let colY = y;
            if (itemType === 'rows') {
                const rowsItems = Array.isArray(item === null || item === void 0 ? void 0 : item.items) ? item.items : [];
                for (const row of rowsItems) {
                    if ((row === null || row === void 0 ? void 0 : row.type) === 'columns' && (row === null || row === void 0 ? void 0 : row.params)) {
                        colY = await this.renderColumnsInBox(row.params, startX, colY, colWidth);
                    }
                    else if ((row === null || row === void 0 ? void 0 : row.type) === 'text' && (row === null || row === void 0 ? void 0 : row.params)) {
                        const fontSize = ((_b = row.params) === null || _b === void 0 ? void 0 : _b.size) || 22;
                        const baseLineHeight = fontSize * 1.2;
                        const lineHeight = baseLineHeight + lineSpace * this.mmToPx;
                        this.ctx.font = `${fontSize}px Arial`;
                        const lines = this.wrapTextToWidth(String((_d = (_c = row.params) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : ''), colWidth);
                        for (const line of lines) {
                            let x = startX;
                            if (((_e = row.params) === null || _e === void 0 ? void 0 : _e.align) === 1) {
                                const w = this.ctx.measureText(line).width;
                                x = startX + (colWidth - w) / 2;
                            }
                            else if (((_f = row.params) === null || _f === void 0 ? void 0 : _f.align) === 2) {
                                const w = this.ctx.measureText(line).width;
                                x = startX + colWidth - w;
                            }
                            const baselineOffset = (lineHeight - fontSize) / 2;
                            this.ctx.fillText(line, x, colY + fontSize + baselineOffset);
                            colY += lineHeight;
                        }
                    }
                }
            }
            else if (itemType === 'image') {
                await new Promise((resolve) => {
                    const img = new Image();
                    if (String((item === null || item === void 0 ? void 0 : item.value) || '').startsWith('http'))
                        img.crossOrigin = 'anonymous';
                    img.onload = () => {
                        let drawWidth = img.width;
                        let drawHeight = img.height;
                        if (drawWidth > colWidth) {
                            const ratio = colWidth / drawWidth;
                            drawWidth = colWidth;
                            drawHeight = drawHeight * ratio;
                        }
                        let x = startX;
                        if ((item === null || item === void 0 ? void 0 : item.align) === 1)
                            x = startX + (colWidth - drawWidth) / 2;
                        else if ((item === null || item === void 0 ? void 0 : item.align) === 2)
                            x = startX + colWidth - drawWidth;
                        this.ctx.drawImage(img, x, colY, drawWidth, drawHeight);
                        colY += drawHeight;
                        resolve();
                    };
                    img.onerror = () => resolve();
                    const v = String((item === null || item === void 0 ? void 0 : item.value) || '').trim();
                    if (!v) {
                        resolve();
                        return;
                    }
                    if (v.startsWith('data:') || v.startsWith('http:') || v.startsWith('https:'))
                        img.src = v;
                    else if (/^[A-Za-z0-9+/=]+$/.test(v))
                        img.src = `data:image/png;base64,${v}`;
                    else {
                        resolve();
                    }
                });
            }
            else if (itemType === 'text') {
                const fontSize = (item === null || item === void 0 ? void 0 : item.size) || 22;
                const baseLineHeight = fontSize * 1.2;
                const lineHeight = baseLineHeight + lineSpace * this.mmToPx;
                this.ctx.font = `${fontSize}px Arial`;
                const lines = this.wrapTextToWidth(String((_g = item === null || item === void 0 ? void 0 : item.value) !== null && _g !== void 0 ? _g : ''), colWidth);
                for (const line of lines) {
                    let x = startX;
                    if ((item === null || item === void 0 ? void 0 : item.align) === 1) {
                        const w = this.ctx.measureText(line).width;
                        x = startX + (colWidth - w) / 2;
                    }
                    else if ((item === null || item === void 0 ? void 0 : item.align) === 2) {
                        const w = this.ctx.measureText(line).width;
                        x = startX + colWidth - w;
                    }
                    const baselineOffset = (lineHeight - fontSize) / 2;
                    this.ctx.fillText(line, x, colY + fontSize + baselineOffset);
                    colY += lineHeight;
                }
            }
            columnHeights[colIdx] = colY - y;
            startX += colWidth;
        }
        const blockHeight = Math.max(...columnHeights, 0);
        if (params.y === undefined) {
            this.currentY = y + blockHeight + marginBottom;
        }
    }
    // 渲染图片
    async renderImage(params) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            // 处理在线图片的跨域问题
            if (((params === null || params === void 0 ? void 0 : params.value) || '').startsWith('http')) {
                img.crossOrigin = 'anonymous';
            }
            img.onload = () => {
                try {
                    const marginTop = (params.marginTop || 0) * this.mmToPx;
                    const marginBottom = (params.marginBottom || 0) * this.mmToPx;
                    const marginLeft = (params.marginLeft || 0) * this.mmToPx;
                    const marginRight = (params.marginRight || 0) * this.mmToPx;
                    // 处理y
                    let y;
                    if (params.y !== undefined) {
                        y = params.y * this.mmToPx;
                    }
                    else {
                        this.currentY += marginTop;
                        y = this.currentY;
                    }
                    // 计算位置和尺寸，左右默认边距始终生效
                    let defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
                    let x = params.x !== undefined
                        ? defaultSideMarginPx + this.mmToPx * this.config.marginLeft + marginLeft + params.x * this.mmToPx
                        : defaultSideMarginPx + this.mmToPx * this.config.marginLeft + marginLeft;
                    let width = img.width;
                    let height = img.height;
                    // 处理压缩
                    const paperWidth = this.canvas.width - (defaultSideMarginPx * 2) - this.mmToPx * (this.config.marginLeft + this.config.marginRight + marginLeft + marginRight);
                    const shouldCompress = params.compress === undefined ? true : params.compress;
                    if (shouldCompress) {
                        // compress为true，超出纸宽则压缩到纸宽一半
                        const halfPaperWidth = paperWidth / 2;
                        if (width > paperWidth) {
                            const ratio = halfPaperWidth / width;
                            width = halfPaperWidth;
                            height = height * ratio;
                        }
                    }
                    else {
                        // compress为false，超出纸宽才压缩到纸宽
                        if (width > paperWidth) {
                            const ratio = paperWidth / width;
                            width = paperWidth;
                            height = height * ratio;
                        }
                    }
                    // 处理对齐
                    if (params.align === 1) { // 居中
                        x = (this.canvas.width - width) / 2;
                    }
                    else if (params.align === 2) { // 右对齐
                        x = this.canvas.width - defaultSideMarginPx - this.mmToPx * this.config.marginRight - marginRight - width;
                    }
                    // 直接在主canvas上绘制图片
                    this.ctx.drawImage(img, x, y, width, height);
                    if (params.y === undefined) {
                        this.currentY = y + height + marginBottom;
                    }
                    resolve();
                }
                catch (error) {
                    reject(new Error(`图片渲染失败: ${error.message}`));
                }
            };
            img.onerror = () => resolve();
            // 处理图片源
            const v = String((params === null || params === void 0 ? void 0 : params.value) || '').trim();
            if (v.startsWith('data:') ||
                v.startsWith('http:') ||
                v.startsWith('https:')) {
                if (v.startsWith('http')) {
                    // 添加时间戳防止缓存
                    const timestamp = new Date().getTime();
                    const url = v.includes('?')
                        ? `${v}&t=${timestamp}`
                        : `${v}?t=${timestamp}`;
                    img.src = url;
                }
                else {
                    // base64图片直接使用
                    img.src = v;
                }
            }
            else if (/^[A-Za-z0-9+/=]+$/.test(v)) {
                // 兼容没有头部的base64字符串，默认按png处理
                img.src = `data:image/png;base64,${v}`;
            }
            else {
                // 不阻塞渲染
                resolve();
            }
        });
    }
    // 渲染二维码
    async renderQRCode(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const qrCanvas = document.createElement('canvas');
                const size = params.size || 9;
                const level = params.level || 2;
                await new Promise((resolveQR, rejectQR) => {
                    QRCode.toCanvas(qrCanvas, params.value, {
                        width: Math.max(size * 5 * this.mmToPx, 48), // 缩放尺寸
                        errorCorrectionLevel: ['L', 'M', 'Q', 'H'][level - 1],
                        margin: 0
                    }, (error) => {
                        if (error) {
                            rejectQR(error);
                        }
                        else {
                            resolveQR(null);
                        }
                    });
                });
                // 如果有logo，添加到二维码中间
                if (params === null || params === void 0 ? void 0 : params.iconQR) {
                    const logoImg = new Image();
                    logoImg.crossOrigin = 'anonymous';
                    await new Promise((resolveLogo, rejectLogo) => {
                        var _a, _b, _c;
                        logoImg.onload = () => {
                            const ctx = qrCanvas.getContext('2d');
                            if (!ctx) {
                                rejectLogo(new Error('无法获取canvas上下文'));
                                return;
                            }
                            // 计算logo尺寸和位置
                            const logoSize = qrCanvas.width * 0.2; // logo大小为二维码的20%
                            const logoX = (qrCanvas.width - logoSize) / 2;
                            const logoY = (qrCanvas.height - logoSize) / 2;
                            // 绘制白色背景
                            ctx.fillStyle = 'white';
                            ctx.fillRect(logoX - 2, logoY - 2, logoSize + 4, logoSize + 4);
                            // 绘制logo
                            ctx.drawImage(logoImg, logoX, logoY, logoSize, logoSize);
                            resolveLogo(null);
                        };
                        logoImg.onerror = () => rejectLogo(new Error('Logo加载失败'));
                        // 处理图片源
                        if (((_a = params.iconQR) === null || _a === void 0 ? void 0 : _a.startsWith('data:')) ||
                            ((_b = params.iconQR) === null || _b === void 0 ? void 0 : _b.startsWith('http:')) ||
                            ((_c = params.iconQR) === null || _c === void 0 ? void 0 : _c.startsWith('https:'))) {
                            if (params.iconQR.startsWith('http')) {
                                const timestamp = new Date().getTime();
                                const url = params.iconQR.includes('?')
                                    ? `${params.iconQR}&t=${timestamp}`
                                    : `${params.iconQR}?t=${timestamp}`;
                                logoImg.src = url;
                            }
                            else {
                                logoImg.src = params.iconQR;
                            }
                        }
                        else {
                            rejectLogo(new Error('不支持的logo图片格式，仅支持 data URL 或 http(s) URL'));
                        }
                    });
                }
                const marginTop = (params.marginTop || 0) * this.mmToPx;
                const marginBottom = (params.marginBottom || 0) * this.mmToPx;
                // 处理y
                let y;
                if (params.y !== undefined) {
                    y = params.y * this.mmToPx;
                }
                else {
                    this.currentY += marginTop;
                    y = this.currentY;
                }
                // 计算位置，左右默认边距始终生效
                let defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
                let x = params.x !== undefined
                    ? params.x * this.mmToPx
                    : defaultSideMarginPx + this.mmToPx * this.config.marginLeft;
                const width = qrCanvas.width;
                if (params.align === 1) { // 居中
                    x = (this.canvas.width - width) / 2;
                }
                else if (params.align === 2) { // 右对齐
                    x = this.canvas.width - defaultSideMarginPx - this.mmToPx * this.config.marginRight - width;
                }
                // 绘制二维码
                this.ctx.drawImage(qrCanvas, x, y);
                if (params.y === undefined) {
                    this.currentY = y + qrCanvas.height + marginBottom;
                }
                resolve();
            }
            catch (error) {
                reject(new Error(`二维码生成失败: ${error.message}`));
            }
        });
    }
    // 渲染条形码
    async renderBarcode(params) {
        return new Promise(async (resolve, reject) => {
            try {
                const canvas = document.createElement('canvas');
                const format = params.format || 'CODE128';
                const barcodeHeight = (params.height || 5) * this.mmToPx;
                const topMargin = (params.marginTop || 0) * this.mmToPx;
                const bottomMargin = (params.marginBottom || 0) * this.mmToPx;
                const hri = params.hri === 1 ? 1 : 0;
                const hriSize = params.hriSize || 18;
                // 处理y
                let y;
                if (params.y !== undefined) {
                    y = params.y * this.mmToPx;
                }
                else {
                    this.currentY += topMargin;
                    y = this.currentY;
                }
                // 计算位置，左右默认边距始终生效
                let defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
                let x = params.x !== undefined
                    ? params.x * this.mmToPx
                    : defaultSideMarginPx + this.mmToPx * this.config.marginLeft;
                // 生成条形码
                // 宽度自适应内容，最小宽度 120px
                const barcodeWidth = Math.max((params.value.length * 16), 120);
                // 计算总高度：条码高度 + hri文字高度（如有）
                let totalHeight = barcodeHeight;
                if (hri === 1) {
                    totalHeight += hriSize + 8; // 8px为条码和文字间距
                }
                canvas.width = barcodeWidth;
                canvas.height = totalHeight;
                // @ts-ignore
                jsBarcode === null || jsBarcode === void 0 ? void 0 : jsBarcode(canvas, params.value, {
                    format: format,
                    width: 2,
                    height: barcodeHeight,
                    displayValue: false, // 不让jsBarcode自带文字
                    margin: 0,
                });
                // 处理对齐
                if (params.align === 1) {
                    x = (this.canvas.width - canvas.width) / 2;
                }
                else if (params.align === 2) {
                    x = this.canvas.width - defaultSideMarginPx - this.mmToPx * this.config.marginRight - canvas.width;
                }
                // 先画条码
                this.ctx.drawImage(canvas, x, y);
                // 再画底部文字（如需要）
                if (hri === 1) {
                    this.ctx.save();
                    this.ctx.font = `${hriSize}px Arial, 'Noto Sans Khmer', 'Khmer UI', 'Noto Sans', 'Segoe UI', sans-serif`;
                    this.ctx.fillStyle = 'black';
                    const text = params.value;
                    const textWidth = this.ctx.measureText(text).width;
                    const textX = x + (canvas.width - textWidth) / 2;
                    const textY = y + barcodeHeight + hriSize + 2; // 2px微调
                    this.ctx.fillText(text, textX, textY);
                    this.ctx.restore();
                }
                if (params.y === undefined) {
                    this.currentY = y + totalHeight + bottomMargin;
                }
                resolve();
            }
            catch (error) {
                reject(new Error(`条形码生成失败: ${error.message}`));
            }
        });
    }
    // 渲染分割线
    renderDividing(params) {
        const marginTop = (params.marginTop || 0) * this.mmToPx;
        const marginBottom = (params.marginBottom || 0) * this.mmToPx;
        // 支持x, y参数（单位mm），如果传入则使用，否则按原有逻辑
        let x;
        if (params.x !== undefined) {
            x = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx + this.mmToPx * (this.config.marginLeft) + params.x * this.mmToPx;
        }
        else {
            x = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx + this.mmToPx * (this.config.marginLeft);
        }
        let y;
        if (params.y !== undefined) {
            y = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx + this.mmToPx * (this.config.marginTop || 0) + params.y * this.mmToPx;
        }
        else {
            this.currentY += marginTop;
            y = this.currentY;
        }
        // 计算分割线宽度，始终有默认边距
        let defaultSideMarginPx = PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM * this.mmToPx;
        let lineWidth;
        lineWidth = this.canvas.width - (defaultSideMarginPx * 2) - this.mmToPx * (this.config.marginLeft + (this.config.marginRight || 0));
        this.ctx.beginPath();
        this.ctx.moveTo(x, y);
        this.ctx.lineTo(x + lineWidth, y);
        // 设置虚线样式
        if (params.value === 'dot') {
            this.ctx.setLineDash([10, 10]);
        }
        else {
            this.ctx.setLineDash([]);
        }
        this.ctx.stroke();
        this.ctx.setLineDash([]); // 重置虚线
        if (params.y === undefined) {
            this.currentY = y + 1.5 * this.mmToPx + marginBottom; // 分割线高度
        }
    }
    // 渲染切纸（模拟）
    renderCutPaper() {
        if (this.config.showCutPaper === false)
            return;
        // 在Canvas上绘制一条虚线表示切纸位置
        // 切纸线横跨整个canvas宽度（不受默认左右边距影响）
        this.ctx.beginPath();
        this.ctx.setLineDash([5, 3]);
        this.ctx.strokeStyle = 'red';
        this.ctx.moveTo(0, this.currentY);
        this.ctx.lineTo(this.canvas.width, this.currentY);
        this.ctx.stroke();
        // 重置样式
        this.ctx.setLineDash([]);
        this.ctx.strokeStyle = 'black';
        // 增加间距
        this.currentY += 10;
    }
    // 新增：画界外虚线
    renderOutOfBoundsLine() {
        const y = this.mmToPx * this.config.height;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.setLineDash([12, 8]);
        this.ctx.strokeStyle = 'red'; // 更明显
        this.ctx.lineWidth = 2;
        this.ctx.moveTo(0, y);
        this.ctx.lineTo(this.canvas.width, y);
        this.ctx.stroke();
        this.ctx.setLineDash([]);
        this.ctx.restore();
    }
}
PrintCanvasRenderer.DEFAULT_SIDE_MARGIN_MM = 3.2; // 默认左右边距 3.2mm

export { PrintCanvasRenderer };
//# sourceMappingURL=index.esm.js.map
